import { HttpClientModule } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { VendorService } from '../../services/vendor.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { StateNames } from '../../views/statename.view';
import { Subscription } from 'rxjs';
import { ReferralFormService } from '../../services/referral-form.service';
import { InstructionsComponent } from '../instructions/instructions.component';
import { JsonFormComponent, JsonFormData } from '../../shared/components/json-form/json-form.component';
import { CommonModule, DatePipe } from '@angular/common';
import { InvolvedParty } from '../../views/involved-party.view';
import { UploadFileComponent } from '../upload-file/upload-file.component';
import { ReCaptchaComponent } from '../../shared/components/re-captcha/re-captcha.component';
import { environment } from '../../../environments/environment';
import { take } from 'rxjs';

@Component({
  selector: 'app-user-details',
  imports: [HttpClientModule, CommonModule, ReactiveFormsModule, JsonFormComponent, UploadFileComponent, ReCaptchaComponent],
  providers: [DatePipe],
  templateUrl: './user-details.component.html',
  styleUrl: './user-details.component.css',
  standalone: true
})
export class UserDetailsComponent implements OnInit {

  modalRef!: NgbModalRef;
  userFormDataPart1: any = {};
  userFormDataPart2: any = {};
  userFormDataPart3: any = {};
  userFormDataPart4: any = {};
  userFormDataPart5: any = {};
  userFormDataPart6: any = {};
  userFormPart1: FormGroup;
  userFormPart2: FormGroup;
  userFormPart3: FormGroup;
  userFormPart4: FormGroup;
  userFormPart5: FormGroup;
  userFormPart6: FormGroup;
  questionsFormData!: JsonFormData;
  questionsForm: FormGroup;
  questionsFormDataJson: any;
  contactFormDataPart1: any = {};
  contactFormDataPart2: any = {};
  contactFormDataPart3: any = {};
  contactFormDataPart4: any = {};
  contactFormPart1: FormGroup;
  contactFormPart2: FormGroup;
  contactFormPart3: FormGroup;
  contactFormPart4: FormGroup;
  providerFormDataPart1: any = {};
  providerFormDataPart2: any = {};
  providerFormPart1: FormGroup;
  providerFormPart2: FormGroup;
  memberFormDataPart1: any = {};
  memberFormDataPart2: any = {};
  memberFormDataPart3: any = {};
  memberFormDataPart4: any = {};
  memberFormPart1: FormGroup;
  memberFormPart2: FormGroup;
  memberFormPart3: FormGroup;
  memberFormPart4: FormGroup;
  noeProviderFormDataPart1: any = {};
  noeProviderFormDataPart2: any = {};
  noeProviderFormDataPart3: any = {};
  noeProviderFormDataPart4: any = {};
  noeProviderFormPart1: FormGroup;
  noeProviderFormPart2: FormGroup;
  noeProviderFormPart3: FormGroup;
  noeProviderFormPart4: FormGroup;
  noeOrgFormDataPart1: any = {};
  noeOrgFormDataPart2: any = {};
  noeOrgFormDataPart3: any = {};
  noeOrgFormDataPart4: any = {};
  noeOrgFormPart1: FormGroup;
  noeOrgFormPart2: FormGroup;
  noeOrgFormPart3: FormGroup;
  noeOrgFormPart4: FormGroup;
  noeIndFormDataPart1: any = {};
  noeIndFormDataPart2: any = {};
  noeIndFormDataPart3: any = {};
  noeIndFormDataPart4: any = {};
  noeIndFormPart1: FormGroup;
  noeIndFormPart2: FormGroup;
  noeIndFormPart3: FormGroup;
  selfReferringPartyDataPart1: any = {};
  selfReferringPartyDataPart2: any = {};
  selfReferringPartyDataPart3: any = {};
  selfReferringPartyDataPart4: any = {};
  selfReferringPartyFormPart1: FormGroup;
  selfReferringPartyFormPart2: FormGroup;
  selfReferringPartyFormPart3: FormGroup;
  selfReferringPartyFormPart4: FormGroup;
  thirdPartyReferringPartyDataPart1: any = {};
  thirdPartyReferringPartyDataPart2: any = {};
  thirdPartyReferringPartyDataPart3: any = {};
  thirdPartyReferringPartyDataPart4: any = {};
  thirdPartyReferringPartyFormPart1: FormGroup;
  thirdPartyReferringPartyFormPart2: FormGroup;
  thirdPartyReferringPartyFormPart3: FormGroup;
  thirdPartyReferringPartyFormPart4: FormGroup;
  individualReferringPartyDataPart1: any = {};
  individualReferringPartyDataPart2: any = {};
  individualReferringPartyDataPart3: any = {};
  individualReferringPartyDataPart4: any = {};
  individualReferringPartyFormPart1: FormGroup;
  individualReferringPartyFormPart2: FormGroup;
  individualReferringPartyFormPart3: FormGroup;
  individualReferringPartyFormPart4: FormGroup;

  isformloaded = false;
  isFormsValid = false;
  isUrlsDisabled = false;
  formdata: any | null;
  statelist: StateNames[] = [];
  payorkey = 0;
  securityCode!: string | null;
  captchaValidated = false;
  verificationCode: string = '';
  verificationErrorMessage: string = '';
  isGeneratingCode: boolean = false;
  private routeSubscription!: Subscription;
  private emailCleared = false;
  isReturningFromWitness = false;
  primaryColor?: string = "";
  InvolvedPartyList: any = [];
  referralTypeList: any = [];
  referralSourceList: any = [];

  agreementForm: FormGroup;
  agreementFormData: any;
  showCaptcha: boolean | undefined;
  isQtnsVisible: boolean = false;
  anonymousMessage: string = '';
  isContactForm: boolean = false;
  isReferringForm: boolean = false;
  contactFormMessageSub: string = '';
  referralFormMessageSub: string = '';
  contactFormMessageSecondline: string = "";
  profileMasterTypeKey: number = 0;
  involvedPartyTypeKey: number = 0;
  isInvolvedPartyForm: boolean = false;
  involvedPartyTypeName: string = '';
  referralFormType: string = '';
  subjectReqFields: any = [];
  associatedLeadReasonId: number = 0;
  checkIsAnonymous: string = '';
  subjectTypeId: any;

  isUploadAttatchment: boolean = false;
  uploadsCompleted: boolean = false;
  sitekey: string;
  uploadFiles: string[] = [];
  requiredFieldData : any;
  countyData: any[] = [];
  private uploadEndDataSub!: Subscription;
  private uploadFileDataSub!: Subscription;
  private startingNewReferral = false;
  leadData: any;

  constructor(
    private userFormBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private referralFormService: ReferralFormService,
    private modalService: NgbModal,
    private vendorService: VendorService,
    private datePipe: DatePipe
  ) {
    this.sitekey = environment.capchaSiteKey;
    this.route.params.subscribe(p => {
      const code = (p['code'] || '');
      if (code && code !== 'final') {
        sessionStorage.setItem('securityCode', code);
        localStorage.setItem('lastSecurityCode', code);
      }
    });
    this.payorkey = parseInt(sessionStorage.getItem('payorkey') ?? '0');
    this.routeSubscription = this.router.events.subscribe(e => {
      if (e instanceof NavigationStart && this.modalRef) {
        this.modalRef.close();
      }
    });
    this.userFormPart1 = this.userFormBuilder.group({});
    this.userFormPart2 = this.userFormBuilder.group({});
    this.userFormPart3 = this.userFormBuilder.group({});
    this.userFormPart4 = this.userFormBuilder.group({});
    this.userFormPart5 = this.userFormBuilder.group({});
    this.userFormPart6 = this.userFormBuilder.group({});
    this.questionsForm = this.userFormBuilder.group({});
    this.agreementForm = this.userFormBuilder.group({});
    this.contactFormPart1 = this.userFormBuilder.group({});
    this.contactFormPart2 = this.userFormBuilder.group({});
    this.contactFormPart3 = this.userFormBuilder.group({});
    this.contactFormPart4 = this.userFormBuilder.group({});
    this.providerFormPart1 = this.userFormBuilder.group({});
    this.providerFormPart2 = this.userFormBuilder.group({});
    this.memberFormPart1 = this.userFormBuilder.group({});
    this.memberFormPart2 = this.userFormBuilder.group({});
    this.memberFormPart3 = this.userFormBuilder.group({});
    this.memberFormPart4 = this.userFormBuilder.group({});
    this.noeProviderFormPart1 = this.userFormBuilder.group({});
    this.noeProviderFormPart2 = this.userFormBuilder.group({});
    this.noeProviderFormPart3 = this.userFormBuilder.group({});
    this.noeProviderFormPart4 = this.userFormBuilder.group({});
    this.noeOrgFormPart1 = this.userFormBuilder.group({});
    this.noeOrgFormPart2 = this.userFormBuilder.group({});
    this.noeOrgFormPart3 = this.userFormBuilder.group({});
    this.noeOrgFormPart4 = this.userFormBuilder.group({});
    this.noeIndFormPart1 = this.userFormBuilder.group({});
    this.noeIndFormPart2 = this.userFormBuilder.group({});
    this.noeIndFormPart3 = this.userFormBuilder.group({});
    this.selfReferringPartyFormPart1 = this.userFormBuilder.group({});
    this.selfReferringPartyFormPart2 = this.userFormBuilder.group({});
    this.selfReferringPartyFormPart3 = this.userFormBuilder.group({});
    this.selfReferringPartyFormPart4 = this.userFormBuilder.group({});
    this.thirdPartyReferringPartyFormPart1 = this.userFormBuilder.group({});
    this.thirdPartyReferringPartyFormPart2 = this.userFormBuilder.group({});
    this.thirdPartyReferringPartyFormPart3 = this.userFormBuilder.group({});
    this.thirdPartyReferringPartyFormPart4 = this.userFormBuilder.group({});
    this.individualReferringPartyFormPart1 = this.userFormBuilder.group({});
    this.individualReferringPartyFormPart2 = this.userFormBuilder.group({});
    this.individualReferringPartyFormPart3 = this.userFormBuilder.group({});
    this.individualReferringPartyFormPart4 = this.userFormBuilder.group({});
  }

  ngOnInit(): void {

    this.startingNewReferral = localStorage.getItem('isNewReferral') === 'true';
    if (this.startingNewReferral) {
      sessionStorage.removeItem('caseActivityKey');
      sessionStorage.removeItem('submissionDone');
      localStorage.removeItem('activeformdata');
      this.uploadsCompleted = false;
      this.uploadFiles = [];
    }
    this.isformloaded = false;

    const savedFormData = localStorage.getItem('activeformdata');
    if (savedFormData) {
      this.formdata = JSON.parse(savedFormData);
    } else {
      const defaultData = this.referralFormService.getFormLoadJSON();
      this.formdata = defaultData;
      localStorage.setItem('activeformdata', JSON.stringify(defaultData));
    }

    this.controlFormInit();
    this.loadFormInit(this.payorkey);

    setTimeout(() => {
      const colorFromStorage = localStorage.getItem('primaryCssColor');
      if (colorFromStorage != null) {
        this.primaryColor = colorFromStorage.toString();
        document.documentElement.style.setProperty('--primary-color', this.primaryColor);
      }
    }, 0);

    this.updateFormValidity();

    this.uploadEndDataSub = this.vendorService.getUploadEndData().subscribe(data => {
      if (data) {
        this.uploadsCompleted = true;
        localStorage.removeItem('isNewReferral');
        sessionStorage.removeItem('returningFromThanksCard');
        this.leadData.ExternalLeadItem.UploadFileNames = this.uploadFiles;
        this.sendReferralEmail(this.leadData);
      }
    });

    this.uploadFileDataSub = this.vendorService.getUploadFileData().subscribe(result => {
      if (result != null && result.length > 0) {
        this.uploadFiles = [];
        result.forEach((item: any) => {
          this.uploadFiles.push(item.fileName);
        });
      }
      else {
        this.uploadFiles = [];
      }
    });
  }

  ngAfterViewInit(): void {
  }

  controlFormInit() {
    const controls = this.formdata.userDetails.controls;
    this.userFormDataPart1["controls"] = controls.slice(0, 1);
    this.userFormDataPart2["controls"] = controls.slice(1, 4);
    this.userFormDataPart3["controls"] = controls.slice(4, 6);
    this.userFormDataPart4["controls"] = controls.slice(6, 7);
    this.userFormDataPart5["controls"] = controls.slice(7, 8);
    this.userFormDataPart6["controls"] = controls.slice(8, 10);

    const contactControls = this.formdata.contactDetails.controls;
    this.contactFormDataPart1["controls"] = contactControls.slice(0, 6);
    this.contactFormDataPart2["controls"] = contactControls.slice(6, 11);
    this.contactFormDataPart3["controls"] = contactControls.slice(11, 12);
    this.contactFormDataPart4["controls"] = contactControls.slice(12, 13);

    const providerControls = this.formdata.providerDetails.controls;
    this.providerFormDataPart1["controls"] = providerControls.slice(0, 9);
    this.providerFormDataPart2["controls"] = providerControls.slice(9, 18);

    const memberControls = this.formdata.memberDetails.controls;
    this.memberFormDataPart1["controls"] = memberControls.slice(0, 9);
    this.memberFormDataPart2["controls"] = memberControls.slice(9, 12);
    this.memberFormDataPart3["controls"] = memberControls.slice(12, 15);
    this.memberFormDataPart4["controls"] = memberControls.slice(15, 17);

    const noeProviderControls = this.formdata.nonEnumeratedProviderDetails.controls;
    this.noeProviderFormDataPart1["controls"] = noeProviderControls.slice(0, 9);
    this.noeProviderFormDataPart2["controls"] = noeProviderControls.slice(9, 14);
    this.noeProviderFormDataPart3["controls"] = noeProviderControls.slice(14, 17);
    this.noeProviderFormDataPart4["controls"] = noeProviderControls.slice(17, 18);

    const noeOrgControls = this.formdata.nonEnumeratedOrganizationDetails.controls;
    this.noeOrgFormDataPart1["controls"] = noeOrgControls.slice(0, 10);
    this.noeOrgFormDataPart2["controls"] = noeOrgControls.slice(10, 15);
    this.noeOrgFormDataPart3["controls"] = noeOrgControls.slice(15, 18);
    this.noeOrgFormDataPart4["controls"] = noeOrgControls.slice(18, 19);

    const noeIndControls = this.formdata.nonEnumeratedIndividualDetails.controls;
    this.noeIndFormDataPart1["controls"] = noeIndControls.slice(0, 8);
    this.noeIndFormDataPart2["controls"] = noeIndControls.slice(8, 13);
    this.noeIndFormDataPart3["controls"] = noeIndControls.slice(13, 16);

    // Setup reactive form validation subscriptions
    this.userFormPart1.statusChanges.subscribe(() => this.updateFormValidity());
    this.userFormPart2.statusChanges.subscribe(() => this.updateFormValidity());
    this.userFormPart3.statusChanges.subscribe(() => this.updateFormValidity());
    this.userFormPart4.statusChanges.subscribe(() => this.updateFormValidity());
    this.userFormPart5.statusChanges.subscribe(() => this.updateFormValidity());
    this.userFormPart6.statusChanges.subscribe(() => this.updateFormValidity());
    this.agreementForm.statusChanges.subscribe(() => this.updateFormValidity());
    this.contactFormPart1.statusChanges.subscribe(() => this.updateFormValidity());
    this.contactFormPart2.statusChanges.subscribe(() => this.updateFormValidity());
    this.contactFormPart3.statusChanges.subscribe(() => this.updateFormValidity());
    this.contactFormPart4.statusChanges.subscribe(() => this.updateFormValidity());
    this.providerFormPart1.statusChanges.subscribe(() => this.updateFormValidity());
    this.providerFormPart2.statusChanges.subscribe(() => this.updateFormValidity());
    this.memberFormPart1.statusChanges.subscribe(() => this.updateFormValidity());
    this.memberFormPart2.statusChanges.subscribe(() => this.updateFormValidity());
    this.memberFormPart3.statusChanges.subscribe(() => this.updateFormValidity());
    this.memberFormPart4.statusChanges.subscribe(() => this.updateFormValidity());
    this.noeProviderFormPart1.statusChanges.subscribe(() => this.updateFormValidity());
    this.noeProviderFormPart2.statusChanges.subscribe(() => this.updateFormValidity());
    this.noeProviderFormPart3.statusChanges.subscribe(() => this.updateFormValidity());
    this.noeProviderFormPart4.statusChanges.subscribe(() => this.updateFormValidity());
    this.noeOrgFormPart1.statusChanges.subscribe(() => this.updateFormValidity());
    this.noeOrgFormPart2.statusChanges.subscribe(() => this.updateFormValidity());
    this.noeOrgFormPart3.statusChanges.subscribe(() => this.updateFormValidity());
    this.noeOrgFormPart4.statusChanges.subscribe(() => this.updateFormValidity());
    this.noeIndFormPart1.statusChanges.subscribe(() => this.updateFormValidity());
    this.noeIndFormPart2.statusChanges.subscribe(() => this.updateFormValidity());
    this.noeIndFormPart3.statusChanges.subscribe(() => this.updateFormValidity());
    this.selfReferringPartyFormPart1.statusChanges.subscribe(() => this.updateFormValidity());
    this.selfReferringPartyFormPart2.statusChanges.subscribe(() => this.updateFormValidity());
    this.selfReferringPartyFormPart3.statusChanges.subscribe(() => this.updateFormValidity());
    this.selfReferringPartyFormPart4.statusChanges.subscribe(() => this.updateFormValidity());
    this.thirdPartyReferringPartyFormPart1.statusChanges.subscribe(() => this.updateFormValidity());
    this.thirdPartyReferringPartyFormPart2.statusChanges.subscribe(() => this.updateFormValidity());
    this.thirdPartyReferringPartyFormPart3.statusChanges.subscribe(() => this.updateFormValidity());
    this.thirdPartyReferringPartyFormPart4.statusChanges.subscribe(() => this.updateFormValidity());
    this.individualReferringPartyFormPart1.statusChanges.subscribe(() => this.updateFormValidity());
    this.individualReferringPartyFormPart2.statusChanges.subscribe(() => this.updateFormValidity());
    this.individualReferringPartyFormPart3.statusChanges.subscribe(() => this.updateFormValidity());
    this.individualReferringPartyFormPart4.statusChanges.subscribe(() => this.updateFormValidity());
  }


  updateFormValidity() {
    this.isFormsValid =
      this.userFormPart1.valid &&
      this.userFormPart2.valid &&
      this.userFormPart3.valid &&
      this.userFormPart4.valid &&
      this.userFormPart5.valid &&
      this.userFormPart6.valid &&
      this.questionsForm.valid &&
      this.agreementForm.valid &&
      this.contactFormPart1.valid &&
      this.contactFormPart2.valid &&
      this.contactFormPart3.valid &&
      this.contactFormPart4.valid &&
      this.selfReferringPartyFormPart1.valid &&
      this.selfReferringPartyFormPart2.valid &&
      this.selfReferringPartyFormPart3.valid &&
      this.selfReferringPartyFormPart4.valid &&
      this.thirdPartyReferringPartyFormPart1.valid &&
      this.thirdPartyReferringPartyFormPart2.valid &&
      this.thirdPartyReferringPartyFormPart3.valid &&
      this.thirdPartyReferringPartyFormPart4.valid &&
      this.individualReferringPartyFormPart1.valid &&
      this.individualReferringPartyFormPart2.valid &&
      this.individualReferringPartyFormPart3.valid &&
      this.individualReferringPartyFormPart4.valid &&
      this.providerFormPart1.valid &&
      this.providerFormPart2.valid &&
      this.memberFormPart1.valid &&
      this.memberFormPart2.valid &&
      this.memberFormPart3.valid &&
      this.memberFormPart4.valid &&
      this.noeProviderFormPart1.valid &&
      this.noeProviderFormPart2.valid &&
      this.noeProviderFormPart3.valid &&
      this.noeProviderFormPart4.valid &&
      this.noeOrgFormPart1.valid &&
      this.noeOrgFormPart2.valid &&
      this.noeOrgFormPart3.valid &&
      this.noeOrgFormPart4.valid &&
      this.noeIndFormPart1.valid &&
      this.noeIndFormPart2.valid &&
      this.noeIndFormPart3.valid;

  }


  loadFormInit(payorkey: number) {
    if (!this.securityCode) {
      this.securityCode = sessionStorage.getItem('securityCode') || localStorage.getItem('lastSecurityCode') || '';
    }

    if (!payorkey) {
      this.vendorService.getPayorIdByCode(this.securityCode).subscribe((result) => {
        if (result == null) {
          this.isUrlsDisabled = true;
          return;
        }
        this.isUrlsDisabled = false;
        this.payorkey = result;
        sessionStorage.setItem("payorkey", this.payorkey.toString());
        this.loadData();
      });
    } else {
      this.loadData();
    }
  }

  private setValidatorIfExists(formPart: any, name: string, required: boolean) {
    const control = formPart.controls.find((x: any) => x.name === name);
    if (control) {
      if (!control.validators) control.validators = {};
      control.validators.required = required;
      control.required = required;
      control.value = "";
    } else {
      console.warn(`Control '${name}' not found in provided form part.`);
    }
  }

  private triggerValidationForDynamicForms() {
    setTimeout(() => {
      this.forceControlsDataChange();
      this.updateFormValidity();
    }, 50);
  }

  private forceControlsDataChange() {
    if (this.providerFormDataPart1?.controls) {
      this.providerFormDataPart1 = { ...this.providerFormDataPart1, controls: [...this.providerFormDataPart1.controls] };
    }
    if (this.providerFormDataPart2?.controls) {
      this.providerFormDataPart2 = { ...this.providerFormDataPart2, controls: [...this.providerFormDataPart2.controls] };
    }
    if (this.memberFormDataPart1?.controls) {
      this.memberFormDataPart1 = { ...this.memberFormDataPart1, controls: [...this.memberFormDataPart1.controls] };
    }
    if (this.memberFormDataPart2?.controls) {
      this.memberFormDataPart2 = { ...this.memberFormDataPart2, controls: [...this.memberFormDataPart2.controls] };
    }
    if (this.memberFormDataPart3?.controls) {
      this.memberFormDataPart3 = { ...this.memberFormDataPart3, controls: [...this.memberFormDataPart3.controls] };
    }
    if (this.memberFormDataPart4?.controls) {
      this.memberFormDataPart4 = { ...this.memberFormDataPart4, controls: [...this.memberFormDataPart4.controls] };
    }
    if (this.noeProviderFormDataPart1?.controls) {
      this.noeProviderFormDataPart1 = { ...this.noeProviderFormDataPart1, controls: [...this.noeProviderFormDataPart1.controls] };
    }
    if (this.noeProviderFormDataPart2?.controls) {
      this.noeProviderFormDataPart2 = { ...this.noeProviderFormDataPart2, controls: [...this.noeProviderFormDataPart2.controls] };
    }
    if (this.noeProviderFormDataPart3?.controls) {
      this.noeProviderFormDataPart3 = { ...this.noeProviderFormDataPart3, controls: [...this.noeProviderFormDataPart3.controls] };
    }
    if (this.noeProviderFormDataPart4?.controls) {
      this.noeProviderFormDataPart4 = { ...this.noeProviderFormDataPart4, controls: [...this.noeProviderFormDataPart4.controls] };
    }
    if (this.noeOrgFormDataPart1?.controls) {
      this.noeOrgFormDataPart1 = { ...this.noeOrgFormDataPart1, controls: [...this.noeOrgFormDataPart1.controls] };
    }
    if (this.noeOrgFormDataPart2?.controls) {
      this.noeOrgFormDataPart2 = { ...this.noeOrgFormDataPart2, controls: [...this.noeOrgFormDataPart2.controls] };
    }
    if (this.noeOrgFormDataPart3?.controls) {
      this.noeOrgFormDataPart3 = { ...this.noeOrgFormDataPart3, controls: [...this.noeOrgFormDataPart3.controls] };
    }
    if (this.noeOrgFormDataPart4?.controls) {
      this.noeOrgFormDataPart4 = { ...this.noeOrgFormDataPart4, controls: [...this.noeOrgFormDataPart4.controls] };
    }
    if (this.noeIndFormDataPart1?.controls) {
      this.noeIndFormDataPart1 = { ...this.noeIndFormDataPart1, controls: [...this.noeIndFormDataPart1.controls] };
    }
    if (this.noeIndFormDataPart2?.controls) {
      this.noeIndFormDataPart2 = { ...this.noeIndFormDataPart2, controls: [...this.noeIndFormDataPart2.controls] };
    }
    if (this.noeIndFormDataPart3?.controls) {
      this.noeIndFormDataPart3 = { ...this.noeIndFormDataPart3, controls: [...this.noeIndFormDataPart3.controls] };
    }
  }

  private setOptionsIfExists(formPart: any, name: string, options: any[]) {
    const control = formPart.controls.find((x: any) => x.name === name);
    if (control) {
      control.options = options;
    } else {
      console.warn(`Control '${name}' for options not found.`);
    }
  }

  loadData() {
    this.vendorService.getRequiredFields(this.payorkey).subscribe((result) => {
      this.requiredFieldData = result;
      this.setValidatorIfExists(this.userFormDataPart3, "incidentStartDt", result.ReferralIncidentStartDate);
      this.setValidatorIfExists(this.userFormDataPart3, "incidentEndDt", result.ReferralIncidentEndDate);
      this.setValidatorIfExists(this.userFormDataPart4, "incidentState", result.ReferralStateIncidentOccurred);
      this.setValidatorIfExists(this.userFormDataPart5, "incidentCounty", result.ReferralCountyIncidentOccurred);

      this.isformloaded = true;
      if (localStorage.getItem('returningFromWitness') === 'true') {
        const emailFormControl = this.userFormPart2.get('email');
        if (emailFormControl) {
          emailFormControl.disable();
        }
      }

      localStorage.setItem("primaryCssColor", result.CssColor);
      this.primaryColor = result.CssColor;
      document.documentElement.style.setProperty('--primary-color', this.primaryColor);

      this.isUploadAttatchment = result.IsUploadAttatchment;
    });

    this.vendorService.getReferringSourcesLookup(this.payorkey).subscribe((result) => {
      const orgOptions = result.map(x => ({ value: x.Id, key: x.Title }));
      this.referralSourceList = result;
      this.setOptionsIfExists(this.userFormDataPart2, "referralSource", orgOptions);
    });

    this.vendorService.getReferralTypesLookup(this.payorkey).subscribe((result) => {
      const orgOptions = result.map(x => ({ value: x.Id, key: x.Title }));
      this.referralTypeList = result;
      this.setOptionsIfExists(this.userFormDataPart2, "referalIssueType", orgOptions);
    });

    this.vendorService.getStateNames().subscribe((result) => {
      this.statelist = result;
      const stateOptions = result.map(x => ({ value: x.Abbreviation, key: x.Abbreviation }));
      this.setOptionsIfExists(this.userFormDataPart4, "incidentState", stateOptions);
      this.setOptionsIfExists(this.contactFormDataPart3, "cdState", stateOptions);
      this.setOptionsIfExists(this.userFormDataPart3, "incidentState", stateOptions);
      this.setOptionsIfExists(this.providerFormDataPart2, "pState", stateOptions);
      this.setOptionsIfExists(this.memberFormDataPart3, "mState", stateOptions);
      this.setOptionsIfExists(this.noeProviderFormDataPart3, "nepState", stateOptions);
      this.setOptionsIfExists(this.noeOrgFormDataPart3, "neoState", stateOptions);
      this.setOptionsIfExists(this.noeIndFormDataPart3, "neiState", stateOptions);
    });

    this.vendorService.getInvolvedPartiesLookup(this.payorkey).subscribe((result) => {
      this.InvolvedPartyList = result;
      const involvedPartyOptions = result.map((x: InvolvedParty) => ({ value: x.Id, key: x.Title }));
      this.setOptionsIfExists(this.userFormDataPart2, "involvedType", involvedPartyOptions);
    });

    this.vendorService.getLeadQuestion(this.payorkey).subscribe((result) => {
      //this.formLoaded = true; 
      if (result.length > 0) {
        this.isQtnsVisible = true;
        if (!Array.isArray(this.questionsFormDataJson) || (Array.isArray(this.formdata.questionsDetails) && this.formdata.questionsDetails.length == 0)) {
          this.questionsFormData = { controls: [] };
          let Qno = 0;
          for (let i = 0; i <= result.length; i++) {
            if (result[i] && typeof result[i].IsQuestionActive !== 'undefined') {
              let active = result[i].IsQuestionActive;
              let required = result[i].IsQuestionRequired;

              if (active) {
                Qno++;
                let label = ((result[i].QuestionText).replace(/<p>/g, '<span>').replace(/<\/p>/g, '</span><br/>')) + '##end';
                let isRequired = required;
                if (isRequired) {
                  label = label.replace(/<br\/>##end/g, '<span class="dynRequired">&nbsp;(Required)</span>')
                  label = label.replace(/##end/g, '<span class="dynRequired">&nbsp;(Required)</span>')
                }
                else {
                  label = label.replace(/##end/g, '')
                }
                if (result[i].QuestionDisplayField == "1") {
                  this.questionsFormData.controls.push({
                    "name": "questiondDrDown" + i,
                    "label": label,
                    "value": "",
                    "type": "select",
                    "options": [
                      {
                        "key": "Yes",
                        "value": "Yes"
                      },
                      {
                        "key": "No",
                        "value": "No"
                      },
                      {
                        "key": "Unknown",
                        "value": "Unknown"
                      }
                      ,
                      {
                        "key": "Not Applicable",
                        "value": "Not Applicable"
                      }
                    ],
                    "validators": {
                      "required": isRequired,
                      "maxLength": 200
                    },
                    placeholder: '',
                    required: false
                  });
                }
                else if (result[i].QuestionDisplayField == "2") {
                  this.questionsFormData.controls.push({
                    "name": "questionTxt" + i,
                    "label": label,
                    "value": "",
                    "type": "textarea",

                    "options": {
                      "showCount": true,
                      "count": 0
                    },
                    "validators": {
                      "required": isRequired,
                      "maxLength": 2000
                    },
                    placeholder: '',
                    required: false
                  });
                }
              }
            }
          }
        }
      }
    })

  }

  userDetailsSubmit() {
    if (
      this.userFormPart1.valid &&
      this.userFormPart2.valid &&
      this.userFormPart3.valid &&
      this.userFormPart4.valid
    ) {
      const tempArr = {
        controls: [
          ...this.userFormDataPart1.controls,
          ...this.userFormDataPart2.controls,
          ...this.userFormDataPart3.controls,
          ...this.userFormDataPart4.controls
        ]
      };

      const existingFormDataStr = localStorage.getItem('activeformdata');
      let fullFormData = existingFormDataStr ? JSON.parse(existingFormDataStr) : {};

      fullFormData.userDetails = tempArr;

      localStorage.setItem('activeformdata', JSON.stringify(fullFormData));
      localStorage.setItem('activeformdata', JSON.stringify(fullFormData));


      const emailControl = this.userFormDataPart2.controls.find((ctrl: any) => ctrl.name === 'email');
      if (emailControl?.value) {
        localStorage.setItem('userEmail', emailControl.value);
      }

      localStorage.setItem('activeformdata', JSON.stringify(fullFormData));

      localStorage.setItem('userEmail', localStorage.getItem('userEmail') || '');
      localStorage.setItem('returningFromUser', 'true');

      this.router.navigate(['witness']);
    }
  }

  valueChangeEvent(data: any) {
    this.checkIsAnonymous = this.userFormPart1.get('isAnonymous')?.value;
    const profileType = this.userFormPart2.get('involvedType')?.value;
    if (data.name == 'isAnonymous') {
      this.resetAnonymousForms();
      switch (this.checkIsAnonymous) {
        case '1':
          this.anonymousMessage = "By choosing to remain anonymous, we are unable to contact you or the third party for further details. Failure to provide detailed information may impact the ability to review the report to its fullest extent.";
          this.contactFormMessageSub = "";
          this.referralFormMessageSub = "";
          this.contactFormMessageSecondline= "";
          this.isContactForm = false;
          this.isReferringForm = false;
          this.referralFormType = '1';
          break;
        case '2':
          this.anonymousMessage = "";
          this.contactFormMessageSub = "";
          this.referralFormMessageSub = "Please enter your information below:";
          this.contactFormMessageSecondline= "";
          this.isContactForm = false;
          this.isReferringForm = true;
          this.referralFormType = '2'; //I am submitting this referral on my own behalf - SelfReferringParty
          this.setSelfReferringPartyForm();
          break;
        case '3':
          this.anonymousMessage = "";
          this.contactFormMessageSub = "As the individual completing this form, please provide your information below:";
          this.referralFormMessageSub = "Please enter the information regarding the individual you are submitting this report for:";
          this.contactFormMessageSecondline= "";
          this.isContactForm = false;
          this.isReferringForm = true;
          this.referralFormType = '3'; //I am submitting this report on behalf of another individual - ThirdPartyReferringParty & IndividualReferringParty
          this.setThirdPartyReferringPartyForm();
          this.setIndividualReferringPartyForm();
          break;
        case '4':
          this.anonymousMessage = "By choosing to have the impacted party remain anonymous, we are unable to contact them for further details. Failure to provide detailed information may impact the ability to review the report to its fullest extent."
          this.contactFormMessageSub = "As the individual completing this form, please provide your information below:";
          this.referralFormMessageSub = "";
          this.contactFormMessageSecondline = "Please enter your contact information:";
          this.isContactForm = true;
          this.isReferringForm = false;
          this.referralFormType = '4'; //I am submitting this report on behalf of another individual but they wish to remain anonymous 
          break;
        default:
          this.checkIsAnonymous = '';
          this.anonymousMessage = "";
          this.contactFormMessageSub = "";
          this.referralFormMessageSub = "";
          this.contactFormMessageSecondline= "";
          this.isContactForm = false;
          this.isReferringForm = false;
          this.referralFormType = '';
          break;
      }
    }

    if (data.name == "referalIssueType") {
      this.associatedLeadReasonId = this.referralTypeList.find((x: any) => x.Id.toString() == this.userFormPart2.get('referalIssueType')?.value)?.AssociatedLeadSourceId ?? 0;
    }

    if (data.name == "involvedType" && profileType != null) {
      let selectedparty = this.InvolvedPartyList.find((x: any) => x.Id == profileType);
      if (selectedparty) {
        this.profileMasterTypeKey = selectedparty.ProfileMasterTypeKey;
        this.subjectTypeId = selectedparty.SubjectTypeKey;
        this.involvedPartyTypeName = selectedparty.Title;
        this.involvedPartyTypeKey = selectedparty.Id;
        this.getSubjectFields();
      }
    }

    // Handle date validation for incident start and end dates
    if (data.name == 'incidentStartDt' || data.name == 'incidentEndDt') {
      this.validateIncidentDates();
    }

    if (data.name == 'mDateOfBirth' || data.name == 'neiDateOfBirth' || data.name == 'sepDateOfBirth'
      || data.name == 'thirdDateOfBirth'
    ) {
      this.validateDateOfBirth();
    }

    if (data.value && data.name.toLowerCase().includes("state")) {
      this.vendorService.getStateCounties(this.statelist.find(y => y.Id == data.value.target.selectedIndex)?.Abbreviation ?? "").subscribe((result) => {
        const stateOptions = result.map(x => ({ "value": x.County, "key": x.County }));
        this.setCounties(data.name, stateOptions);
      });
    }
    this.updateFormValidity();
  }

  validateDateOfBirth() {
    const dateOfBirthControl = this.memberFormPart1.get('mDateOfBirth');
    const neiDateOfBirthControl = this.noeIndFormPart1.get('neiDateOfBirth');
    const sepDateOfBirthControl = this.selfReferringPartyFormPart1.get('sepDateOfBirth');
    const thirdDateOfBirthControl = this.thirdPartyReferringPartyFormPart1.get('thirdDateOfBirth');

    let isDateError = false;

    if (dateOfBirthControl) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const dateOfBirth = dateOfBirthControl.value;
      const dateOfBirthObj = dateOfBirth instanceof Date ? dateOfBirth : new Date(dateOfBirth);

      if (dateOfBirthObj && dateOfBirthObj > today) {
        const currentErrors = dateOfBirthControl.errors || {};
        dateOfBirthControl.setErrors({
          ...currentErrors,
          dateRangeInvalid: { message: 'Date of Birth cannot be in the future.' }
        });
        isDateError = true;
      }
    }

    if (neiDateOfBirthControl) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const dateOfBirth = neiDateOfBirthControl.value;
      const dateOfBirthObj = dateOfBirth instanceof Date ? dateOfBirth : new Date(dateOfBirth);

      if (dateOfBirthObj && dateOfBirthObj > today) {
        const currentErrors = neiDateOfBirthControl.errors || {};
        neiDateOfBirthControl.setErrors({
          ...currentErrors,
          dateRangeInvalid: { message: 'Date of Birth cannot be in the future.' }
        });
        isDateError = true;
      }
    }

    if (sepDateOfBirthControl) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const dateOfBirth = sepDateOfBirthControl.value;
      const dateOfBirthObj = dateOfBirth instanceof Date ? dateOfBirth : new Date(dateOfBirth);

      if (dateOfBirthObj && dateOfBirthObj > today) {
        const currentErrors = sepDateOfBirthControl.errors || {};
        sepDateOfBirthControl.setErrors({
          ...currentErrors,
          dateRangeInvalid: { message: 'Date of Birth cannot be in the future.' }
        });
        isDateError = true;
      }
    }

    if (thirdDateOfBirthControl) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const dateOfBirth = thirdDateOfBirthControl.value;
      const dateOfBirthObj = dateOfBirth instanceof Date ? dateOfBirth : new Date(dateOfBirth);

      if (dateOfBirthObj && dateOfBirthObj > today) {
        const currentErrors = thirdDateOfBirthControl.errors || {};
        thirdDateOfBirthControl.setErrors({
          ...currentErrors,
          dateRangeInvalid: { message: 'Date of Birth cannot be in the future.' }
        });
        isDateError = true;
      }
    }


    if (!isDateError) {
      // Clear the date range error if dates are valid
      if (dateOfBirthControl && dateOfBirthControl.errors && dateOfBirthControl.errors['dateRangeInvalid']) {
        delete dateOfBirthControl.errors['dateRangeInvalid'];
        if (Object.keys(dateOfBirthControl.errors).length === 0) {
          dateOfBirthControl.setErrors(null);
        }
      }
      if (neiDateOfBirthControl && neiDateOfBirthControl.errors && neiDateOfBirthControl.errors['dateRangeInvalid']) {
        delete neiDateOfBirthControl.errors['dateRangeInvalid'];
        if (Object.keys(neiDateOfBirthControl.errors).length === 0) {
          neiDateOfBirthControl.setErrors(null);
        }
      }

      if (sepDateOfBirthControl && sepDateOfBirthControl.errors && sepDateOfBirthControl.errors['dateRangeInvalid']) {
        delete sepDateOfBirthControl.errors['dateRangeInvalid'];
        if (Object.keys(sepDateOfBirthControl.errors).length === 0) {
          sepDateOfBirthControl.setErrors(null);
        }
      }

      if (thirdDateOfBirthControl && thirdDateOfBirthControl.errors && thirdDateOfBirthControl.errors['dateRangeInvalid']) {
        delete thirdDateOfBirthControl.errors['dateRangeInvalid'];
        if (Object.keys(thirdDateOfBirthControl.errors).length === 0) {
          thirdDateOfBirthControl.setErrors(null);
        }
      }
    }

  }
  validateIncidentDates() {
    const startDateControl = this.userFormPart3.get('incidentStartDt');
    const endDateControl = this.userFormPart3.get('incidentEndDt');

    if (!startDateControl || !endDateControl) {
      return;
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const startDate = startDateControl.value;
    const endDate = endDateControl.value;

    // Convert to Date objects if they're not already
    const startDateObj = startDate instanceof Date ? startDate : new Date(startDate);
    const endDateObj = endDate instanceof Date ? endDate : new Date(endDate);

    let isDateError = false;

    if ((startDateObj && startDateObj > today) || (endDateObj && endDateObj > today)) {
      if (startDateObj && startDateObj > today) {
        const currentErrors = startDateControl.errors || {};
        startDateControl.setErrors({
          ...currentErrors,
          dateRangeInvalid: { message: 'Date cannot be in the future or Incident End Date cannot be prior to the Incident Start Date.' }
        });
        isDateError = true;
      }
      if (endDateObj && endDateObj > today) {
        const currentErrors = endDateControl.errors || {};
        endDateControl.setErrors({
          ...currentErrors,
          dateRangeInvalid: { message: 'Date cannot be in the future or Incident End Date cannot be prior to the Incident Start Date.' }
        });
        isDateError = true;
      }
    } else if (endDateObj < startDateObj) {
      // Set error on end date control
      const currentErrors = endDateControl.errors || {};
      endDateControl.setErrors({
        ...currentErrors,
        dateRangeInvalid: { message: 'Date cannot be in the future or Incident End Date cannot be prior to the Incident Start Date.' }
      });
      isDateError = true;
    }

    if (!isDateError) {
      // Clear the date range error if dates are valid
      if (endDateControl.errors && endDateControl.errors['dateRangeInvalid']) {
        delete endDateControl.errors['dateRangeInvalid'];
        if (Object.keys(endDateControl.errors).length === 0) {
          endDateControl.setErrors(null);
        }
      }
    }
  }

  ngOnDestroy() {
    if (this.routeSubscription) {
      this.routeSubscription.unsubscribe();
    }
    if (this.uploadEndDataSub) {
      this.uploadEndDataSub.unsubscribe();
    }

    if (this.uploadFileDataSub) {
      this.uploadFileDataSub.unsubscribe();
    }
  }

  allowOnlyNumbers(event: KeyboardEvent) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }
  isCodeValid(): boolean {
    return /^\d{6}$/.test(this.verificationCode);
  }

  get isEmailPreviouslyValidated(): boolean {
    return localStorage.getItem('emailValidated') === 'true';
  }

  get isEmailValidatedAndSame(): boolean {
    const currentEmail = this.userFormPart2.get('email')?.value;
    const validatedEmail = localStorage.getItem('validatedEmail');
    const emailValidated = localStorage.getItem('emailValidated') === 'true';
    return emailValidated && currentEmail === validatedEmail;
  }

  getSubjectFields(): void {
    if (!this.involvedPartyTypeKey || !this.payorkey) {
      console.warn('Missing required data for getSubjectFields:', {
        involvedPartyTypeKey: this.involvedPartyTypeKey,
        payorkey: this.payorkey
      });
      return;
    }

    this.vendorService.getSubjectRequiredFieldsByInvolvedParty(this.involvedPartyTypeKey, this.payorkey)
      .subscribe({
        next: (result) => {
          if (result?.length > 0) {
            this.isInvolvedPartyForm = true;
            this.subjectReqFields = result;
            this.assignSubjectType();
          } else {
            this.isInvolvedPartyForm = false;
            this.subjectReqFields = [];
          }
        },
        error: (error) => {
          console.error('Error fetching subject required fields:', error);
          this.isInvolvedPartyForm = false;
          this.subjectReqFields = [];
        }
      });
  }

  agreementDetailsSubmit() {
    let sourceCode = "";
    let namePrefix = "";
    let firstName = "";
    let middleName = "";
    let lastName = "";
    let nameSuffix = "";
    let designation = "";
    let ssn = "";
    let licenceNumber = "";
    let manualSubjectID = "";
    let npi = "";
    let tin = "";
    let medicaidId = "";
    let medicareId = "";
    let otherId = "";
    let providerType = "";
    let ProviderSpecialty = "";
    let taxonomyId = "";
    let other = "";
    let streetAddress1 = "";
    let streetAddress2 = "";
    let city = "";
    let state = "";
    let county = "";
    let zip = "";
    let country = "";
    let phone = "";
    let secondaryPhone = "";
    let fax = "";
    let email = "";
    let gender = "";
    let plan = "";
    let program = "";
    let lob = "";
    let group = "";
    let contactNamePrefix = "";
    let contactFirstName = "";
    let contactMiddleName = "";
    let contactLastName = "";
    let contactDesignation = "";
    let dateOfBirth = "";
    let subjectPdfdateOfBirth = "";

    let ContactFormFirstName = "";
    let ContactFormLastName = "";
    let ContactFormNameSuffix = "";
    let ContactFormTitle = "";
    let ContactFormAgencyName = "";
    let ContactFormindRelationship = "";
    let ContactFormPhone = "";
    let ContactFormEmail = "";
    let ContactFormAddress1 = "";
    let ContactFormAddress2 = "";
    let ContactFormCity = "";
    let ContactFormState = "";
    let ContactFormZip = "";

    let IsAnonymousParty = false;

    let ReferralOrganizationName = "";
    let ReferralFirstName = "";
    let ReferralMiddleName = "";
    let ReferralLastName = "";
    let ReferralSuffix = "";
    let ReferralDateOfBirth = "";
    let ReferralTitle = "";
    let ReferralIdNumber = "";
    let ReferralSSN = "";
    let ReferralPhone = "";
    let ReferralEmail = "";
    let ReferralRelationship = "";
    let ReferralAddress1 = "";
    let ReferralAddress2 = "";
    let ReferralCity = "";
    let ReferralState = "";
    let ReferralZipCode = "";
    let ReferralCounty = "";
    let ReferralReceivedDate = "";

    switch (this.profileMasterTypeKey) {
      case 1:
        sourceCode = this.formdata.providerDetails.controls.find((x: { name: any; }) => x.name == "pOrgName").value;
        firstName = this.formdata.providerDetails.controls.find((x: { name: any; }) => x.name == "pFirstName").value;
        lastName = this.formdata.providerDetails.controls.find((x: { name: any; }) => x.name == "pLastName").value;
        nameSuffix = this.formdata.providerDetails.controls.find((x: { name: any; }) => x.name == "pNameSuffix").value;
        designation = this.formdata.providerDetails.controls.find((x: { name: any; }) => x.name == "pDesignation").value;
        licenceNumber = this.formdata.providerDetails.controls.find((x: { name: any; }) => x.name == "pLicenseNo").value;
        manualSubjectID = this.formdata.providerDetails.controls.find((x: { name: any; }) => x.name == "pManualSubjectID").value;
        npi = this.formdata.providerDetails.controls.find((x: { name: any; }) => x.name == "pNPI").value;
        tin = this.formdata.providerDetails.controls.find((x: { name: any; }) => x.name == "pTIN").value;
        streetAddress1 = this.formdata.providerDetails.controls.find((x: { name: any; }) => x.name == "pStreetAddress1").value;
        streetAddress2 = this.formdata.providerDetails.controls.find((x: { name: any; }) => x.name == "pStreetAddress2").value;
        city = this.formdata.providerDetails.controls.find((x: { name: any; }) => x.name == "pCity").value;
        state = this.formdata.providerDetails.controls.find((x: { name: any; }) => x.name == "pState").value;
        county = this.formdata.providerDetails.controls.find((x: { name: any; }) => x.name == "pCounty").value;
        zip = this.formdata.providerDetails.controls.find((x: { name: any; }) => x.name == "pZip").value;
        country = this.formdata.providerDetails.controls.find((x: { name: any; }) => x.name == "pCountry").value;
        phone = this.formdata.providerDetails.controls.find((x: { name: any; }) => x.name == "pPhone").value;
        email = this.formdata.providerDetails.controls.find((x: { name: any; }) => x.name == "pEmail").value;
        break;
      case 2:
        firstName = this.formdata.memberDetails.controls.find((x: { name: any; }) => x.name == "mFirstName").value;
        middleName = this.formdata.memberDetails.controls.find((x: { name: any; }) => x.name == "mMiddleName").value;
        lastName = this.formdata.memberDetails.controls.find((x: { name: any; }) => x.name == "mLastName").value;
        nameSuffix = this.formdata.memberDetails.controls.find((x: { name: any; }) => x.name == "mNameSuffix").value;
        dateOfBirth = this.formdata.memberDetails.controls.find((x: { name: any; }) => x.name == "mDateOfBirth").value;
        gender = this.formdata.memberDetails.controls.find((x: { name: any; }) => x.name == "mGender").value;
        other = this.formdata.memberDetails.controls.find((x: { name: any; }) => x.name == "mOther").value;
        manualSubjectID = this.formdata.memberDetails.controls.find((x: { name: any; }) => x.name == "mID").value;
        ssn = this.formdata.memberDetails.controls.find((x: { name: any; }) => x.name == "mSSN").value;
        streetAddress1 = this.formdata.memberDetails.controls.find((x: { name: any; }) => x.name == "mAddress1").value;
        streetAddress2 = this.formdata.memberDetails.controls.find((x: { name: any; }) => x.name == "mAddress2").value;
        city = this.formdata.memberDetails.controls.find((x: { name: any; }) => x.name == "mCity").value;
        state = this.formdata.memberDetails.controls.find((x: { name: any; }) => x.name == "mState").value;
        county = this.formdata.memberDetails.controls.find((x: { name: any; }) => x.name == "mCounty").value;
        zip = this.formdata.memberDetails.controls.find((x: { name: any; }) => x.name == "mZip").value;
        phone = this.formdata.memberDetails.controls.find((x: { name: any; }) => x.name == "mPrimaryPhone").value;
        email = this.formdata.memberDetails.controls.find((x: { name: any; }) => x.name == "mEmail").value;
        break;
      case 3:
        sourceCode = this.formdata.nonEnumeratedProviderDetails.controls.find((x: { name: any; }) => x.name == "nepOrgName").value;
        firstName = this.formdata.nonEnumeratedProviderDetails.controls.find((x: { name: any; }) => x.name == "nepFirstName").value;
        middleName = this.formdata.nonEnumeratedProviderDetails.controls.find((x: { name: any; }) => x.name == "nepMiddleName").value;
        lastName = this.formdata.nonEnumeratedProviderDetails.controls.find((x: { name: any; }) => x.name == "nepLastName").value;
        nameSuffix = this.formdata.nonEnumeratedProviderDetails.controls.find((x: { name: any; }) => x.name == "nepNameSuffix").value;
        designation = this.formdata.nonEnumeratedProviderDetails.controls.find((x: { name: any; }) => x.name == "nepDesignation").value;
        ssn = this.formdata.nonEnumeratedProviderDetails.controls.find((x: { name: any; }) => x.name == "nepSsn").value;
        licenceNumber = this.formdata.nonEnumeratedProviderDetails.controls.find((x: { name: any; }) => x.name == "nepLicenseNo").value;
        other = this.formdata.nonEnumeratedProviderDetails.controls.find((x: { name: any; }) => x.name == "nepOther").value;
        phone = this.formdata.nonEnumeratedProviderDetails.controls.find((x: { name: any; }) => x.name == "nepPrimaryPhone").value;
        email = this.formdata.nonEnumeratedProviderDetails.controls.find((x: { name: any; }) => x.name == "nepEmail").value;
        streetAddress1 = this.formdata.nonEnumeratedProviderDetails.controls.find((x: { name: any; }) => x.name == "nepStreetAddress1").value;
        streetAddress2 = this.formdata.nonEnumeratedProviderDetails.controls.find((x: { name: any; }) => x.name == "nepStreetAddress2").value;
        city = this.formdata.nonEnumeratedProviderDetails.controls.find((x: { name: any; }) => x.name == "nepCity").value;
        state = this.formdata.nonEnumeratedProviderDetails.controls.find((x: { name: any; }) => x.name == "nepState").value;
        county = this.formdata.nonEnumeratedProviderDetails.controls.find((x: { name: any; }) => x.name == "nepCounty").value;
        zip = this.formdata.nonEnumeratedProviderDetails.controls.find((x: { name: any; }) => x.name == "nepZip").value;
        country = this.formdata.nonEnumeratedProviderDetails.controls.find((x: { name: any; }) => x.name == "nepCountry").value;
        break;
      case 4:
        sourceCode = this.formdata.nonEnumeratedOrganizationDetails.controls.find((x: { name: any; }) => x.name == "neoOrgName").value;
        tin = this.formdata.nonEnumeratedOrganizationDetails.controls.find((x: { name: any; }) => x.name == "neoTIN").value;
        licenceNumber = this.formdata.nonEnumeratedOrganizationDetails.controls.find((x: { name: any; }) => x.name == "neoLicenseNo").value;
        other = this.formdata.nonEnumeratedOrganizationDetails.controls.find((x: { name: any; }) => x.name == "neoOther").value;
        otherId = this.formdata.nonEnumeratedOrganizationDetails.controls.find((x: { name: any; }) => x.name == "neoOtherId").value;
        contactNamePrefix = this.formdata.nonEnumeratedOrganizationDetails.controls.find((x: { name: any; }) => x.name == "neoContactNamePrefix").value;
        contactFirstName = this.formdata.nonEnumeratedOrganizationDetails.controls.find((x: { name: any; }) => x.name == "neoContactFirstName").value;
        contactMiddleName = this.formdata.nonEnumeratedOrganizationDetails.controls.find((x: { name: any; }) => x.name == "neoContactMiddleName").value;
        contactLastName = this.formdata.nonEnumeratedOrganizationDetails.controls.find((x: { name: any; }) => x.name == "neoContactLastName").value;
        contactDesignation = this.formdata.nonEnumeratedOrganizationDetails.controls.find((x: { name: any; }) => x.name == "neoContactDesignation").value;
        phone = this.formdata.nonEnumeratedOrganizationDetails.controls.find((x: { name: any; }) => x.name == "neoPhone").value;
        email = this.formdata.nonEnumeratedOrganizationDetails.controls.find((x: { name: any; }) => x.name == "neoEmail").value;
        streetAddress1 = this.formdata.nonEnumeratedOrganizationDetails.controls.find((x: { name: any; }) => x.name == "neoStreetAddress1").value;
        streetAddress2 = this.formdata.nonEnumeratedOrganizationDetails.controls.find((x: { name: any; }) => x.name == "neoStreetAddress2").value;
        city = this.formdata.nonEnumeratedOrganizationDetails.controls.find((x: { name: any; }) => x.name == "neoCity").value;
        state = this.formdata.nonEnumeratedOrganizationDetails.controls.find((x: { name: any; }) => x.name == "neoState").value;
        county = this.formdata.nonEnumeratedOrganizationDetails.controls.find((x: { name: any; }) => x.name == "neoCounty").value;
        zip = this.formdata.nonEnumeratedOrganizationDetails.controls.find((x: { name: any; }) => x.name == "neoZip").value;
        country = this.formdata.nonEnumeratedOrganizationDetails.controls.find((x: { name: any; }) => x.name == "neoCountry").value;
        break;
      case 5:
        namePrefix = this.formdata.nonEnumeratedIndividualDetails.controls.find((x: { name: any; }) => x.name == "neiNamePrefix").value;
        firstName = this.formdata.nonEnumeratedIndividualDetails.controls.find((x: { name: any; }) => x.name == "neiFirstName").value;
        middleName = this.formdata.nonEnumeratedIndividualDetails.controls.find((x: { name: any; }) => x.name == "neiMiddleName").value;
        lastName = this.formdata.nonEnumeratedIndividualDetails.controls.find((x: { name: any; }) => x.name == "neiLastName").value;
        nameSuffix = this.formdata.nonEnumeratedIndividualDetails.controls.find((x: { name: any; }) => x.name == "neiNameSuffix").value;
        designation = this.formdata.nonEnumeratedIndividualDetails.controls.find((x: { name: any; }) => x.name == "neiDesignation").value;
        dateOfBirth = this.formdata.nonEnumeratedIndividualDetails.controls.find((x: { name: any; }) => x.name == "neiDateOfBirth").value;
        other = this.formdata.nonEnumeratedIndividualDetails.controls.find((x: { name: any; }) => x.name == "neiOther").value;
        phone = this.formdata.nonEnumeratedIndividualDetails.controls.find((x: { name: any; }) => x.name == "neiPrimaryPhone").value;
        email = this.formdata.nonEnumeratedIndividualDetails.controls.find((x: { name: any; }) => x.name == "neiEmail").value;
        streetAddress1 = this.formdata.nonEnumeratedIndividualDetails.controls.find((x: { name: any; }) => x.name == "neiStreetAddress1").value;
        streetAddress2 = this.formdata.nonEnumeratedIndividualDetails.controls.find((x: { name: any; }) => x.name == "neiStreetAddress2").value;
        city = this.formdata.nonEnumeratedIndividualDetails.controls.find((x: { name: any; }) => x.name == "neiCity").value;
        state = this.formdata.nonEnumeratedIndividualDetails.controls.find((x: { name: any; }) => x.name == "neiState").value;
        county = this.formdata.nonEnumeratedIndividualDetails.controls.find((x: { name: any; }) => x.name == "neiCounty").value;
        zip = this.formdata.nonEnumeratedIndividualDetails.controls.find((x: { name: any; }) => x.name == "neiZip").value;
        break;
    }
    let isAnonymousValue = Number(this.checkIsAnonymous);

    switch (this.checkIsAnonymous) {
      case '1':
        IsAnonymousParty = true;
        break;
      case '2':
        IsAnonymousParty = false;
        ReferralFirstName = this.formdata.selfReferringPartyDetails.controls.find((x: { name: any; }) => x.name == "sepFirstName")?.value;
        ReferralMiddleName = this.formdata.selfReferringPartyDetails.controls.find((x: { name: any; }) => x.name == "sepMiddleName")?.value;
        ReferralLastName = this.formdata.selfReferringPartyDetails.controls.find((x: { name: any; }) => x.name == "sepLastName")?.value;
        ReferralSuffix = this.formdata.selfReferringPartyDetails.controls.find((x: { name: any; }) => x.name == "sepSuffix")?.value;
        ReferralDateOfBirth = this.formdata.selfReferringPartyDetails.controls.find((x: { name: any; }) => x.name == "sepDateOfBirth")?.value;
        ReferralTitle = this.formdata.selfReferringPartyDetails.controls.find((x: { name: any; }) => x.name == "sepTitle")?.value;
        ReferralOrganizationName = this.formdata.selfReferringPartyDetails.controls.find((x: { name: any; }) => x.name == "sepOrgName")?.value;
        ReferralIdNumber = this.formdata.selfReferringPartyDetails.controls.find((x: { name: any; }) => x.name == "sepIdNumber")?.value;
        ReferralSSN = this.formdata.selfReferringPartyDetails.controls.find((x: { name: any; }) => x.name == "sepSSN")?.value;
        ReferralPhone = this.formdata.selfReferringPartyDetails.controls.find((x: { name: any; }) => x.name == "sepPhone")?.value;
        ReferralEmail = this.formdata.selfReferringPartyDetails.controls.find((x: { name: any; }) => x.name == "sepEmail")?.value;
        ReferralAddress1 = this.formdata.selfReferringPartyDetails.controls.find((x: { name: any; }) => x.name == "sepAddress1")?.value;
        ReferralAddress2 = this.formdata.selfReferringPartyDetails.controls.find((x: { name: any; }) => x.name == "sepAddress2")?.value;
        ReferralCity = this.formdata.selfReferringPartyDetails.controls.find((x: { name: any; }) => x.name == "sepCity")?.value;
        ReferralState = this.formdata.selfReferringPartyDetails.controls.find((x: { name: any; }) => x.name == "sepState")?.value;
        ReferralZipCode = this.formdata.selfReferringPartyDetails.controls.find((x: { name: any; }) => x.name == "sepZip")?.value;
        ReferralCounty = this.formdata.selfReferringPartyDetails.controls.find((x: { name: any; }) => x.name == "sepCounty")?.value;
        ReferralRelationship = this.formdata.selfReferringPartyDetails.controls.find((x: { name: any; }) => x.name == "sepRelationship")?.value;
        break;
      case '3':
        IsAnonymousParty = false;
        ReferralFirstName = this.formdata.thirdPartyReferringPartyDetails.controls.find((x: { name: any; }) => x.name == "thirdFirstName")?.value;
        ReferralMiddleName = this.formdata.thirdPartyReferringPartyDetails.controls.find((x: { name: any; }) => x.name == "thirdMiddleName")?.value;
        ReferralLastName = this.formdata.thirdPartyReferringPartyDetails.controls.find((x: { name: any; }) => x.name == "thirdLastName")?.value;
        ReferralSuffix = this.formdata.thirdPartyReferringPartyDetails.controls.find((x: { name: any; }) => x.name == "thirdSuffix")?.value;
        ReferralDateOfBirth = this.formdata.thirdPartyReferringPartyDetails.controls.find((x: { name: any; }) => x.name == "thirdDateOfBirth")?.value;
        ReferralTitle = this.formdata.thirdPartyReferringPartyDetails.controls.find((x: { name: any; }) => x.name == "thirdTitle")?.value;
        ReferralOrganizationName = this.formdata.thirdPartyReferringPartyDetails.controls.find((x: { name: any; }) => x.name == "thirdOrgName")?.value;
        ReferralIdNumber = this.formdata.thirdPartyReferringPartyDetails.controls.find((x: { name: any; }) => x.name == "thirdIdNumber")?.value;
        ReferralSSN = this.formdata.thirdPartyReferringPartyDetails.controls.find((x: { name: any; }) => x.name == "thirdSSN")?.value;
        ReferralPhone = this.formdata.thirdPartyReferringPartyDetails.controls.find((x: { name: any; }) => x.name == "thirdPhone")?.value;
        ReferralEmail = this.formdata.thirdPartyReferringPartyDetails.controls.find((x: { name: any; }) => x.name == "thirdEmail")?.value;
        ReferralAddress1 = this.formdata.thirdPartyReferringPartyDetails.controls.find((x: { name: any; }) => x.name == "thirdAddress1")?.value;
        ReferralAddress2 = this.formdata.thirdPartyReferringPartyDetails.controls.find((x: { name: any; }) => x.name == "thirdAddress2")?.value;
        ReferralCity = this.formdata.thirdPartyReferringPartyDetails.controls.find((x: { name: any; }) => x.name == "thirdCity")?.value;
        ReferralState = this.formdata.thirdPartyReferringPartyDetails.controls.find((x: { name: any; }) => x.name == "thirdState")?.value;
        ReferralZipCode = this.formdata.thirdPartyReferringPartyDetails.controls.find((x: { name: any; }) => x.name == "thirdZip")?.value;
        ReferralCounty = this.formdata.thirdPartyReferringPartyDetails.controls.find((x: { name: any; }) => x.name == "thirdCounty")?.value;
        ReferralRelationship = this.formdata.thirdPartyReferringPartyDetails.controls.find((x: { name: any; }) => x.name == "thirdRelationship")?.value;

        ContactFormFirstName = this.formdata.individualReferringPartyDetails.controls.find((x: { name: any; }) => x.name == "indFirstName")?.value;
        ContactFormLastName = this.formdata.individualReferringPartyDetails.controls.find((x: { name: any; }) => x.name == "indLastName")?.value;
        ContactFormNameSuffix = this.formdata.individualReferringPartyDetails.controls.find((x: { name: any; }) => x.name == "indSuffix")?.value;
        ContactFormTitle = this.formdata.individualReferringPartyDetails.controls.find((x: { name: any; }) => x.name == "indTitle")?.value;
        ContactFormAgencyName = this.formdata.individualReferringPartyDetails.controls.find((x: { name: any; }) => x.name == "indOrgName")?.value;
        ContactFormindRelationship = this.formdata.individualReferringPartyDetails.controls.find((x: { name: any; }) => x.name == "indRelationship")?.value;
        ContactFormPhone = this.formdata.individualReferringPartyDetails.controls.find((x: { name: any; }) => x.name == "indPhone")?.value;
        ContactFormEmail = this.formdata.individualReferringPartyDetails.controls.find((x: { name: any; }) => x.name == "indEmail")?.value;
        ContactFormAddress1 = this.formdata.individualReferringPartyDetails.controls.find((x: { name: any; }) => x.name == "indAddress1")?.value;
        ContactFormAddress2 = this.formdata.individualReferringPartyDetails.controls.find((x: { name: any; }) => x.name == "indAddress2")?.value;
        ContactFormCity = this.formdata.individualReferringPartyDetails.controls.find((x: { name: any; }) => x.name == "indCity")?.value;
        ContactFormState = this.formdata.individualReferringPartyDetails.controls.find((x: { name: any; }) => x.name == "indState")?.value;
        ContactFormZip = this.formdata.individualReferringPartyDetails.controls.find((x: { name: any; }) => x.name == "indZip")?.value;
        break;
      case '4':
        IsAnonymousParty = true;
        ContactFormFirstName = this.formdata.contactDetails.controls.find((x: { name: any; }) => x.name == "cdFirstName")?.value;
        ContactFormLastName = this.formdata.contactDetails.controls.find((x: { name: any; }) => x.name == "cdLastName")?.value;
        ContactFormNameSuffix = this.formdata.contactDetails.controls.find((x: { name: any; }) => x.name == "cdSuffix")?.value;
        ContactFormTitle = this.formdata.contactDetails.controls.find((x: { name: any; }) => x.name == "cdTitle")?.value;
        ContactFormAgencyName = this.formdata.contactDetails.controls.find((x: { name: any; }) => x.name == "cdOrgName")?.value;
        ContactFormindRelationship = this.formdata.contactDetails.controls.find((x: { name: any; }) => x.name == "cdRelationship")?.value;
        ContactFormPhone = this.formdata.contactDetails.controls.find((x: { name: any; }) => x.name == "cdPhone")?.value;
        ContactFormEmail = this.formdata.contactDetails.controls.find((x: { name: any; }) => x.name == "cdEmail")?.value;
        ContactFormAddress1 = this.formdata.contactDetails.controls.find((x: { name: any; }) => x.name == "cdAddress1")?.value;
        ContactFormAddress2 = this.formdata.contactDetails.controls.find((x: { name: any; }) => x.name == "cdAddress2")?.value;
        ContactFormCity = this.formdata.contactDetails.controls.find((x: { name: any; }) => x.name == "cdCity")?.value;
        ContactFormState = this.formdata.contactDetails.controls.find((x: { name: any; }) => x.name == "cdState")?.value;
        ContactFormZip = this.formdata.contactDetails.controls.find((x: { name: any; }) => x.name == "cdZip")?.value;
        break;
      default:
        IsAnonymousParty = false;
        break;
    }
    subjectPdfdateOfBirth = dateOfBirth;
    dateOfBirth = (dateOfBirth == null) ? '' : (this.datePipe.transform(this.createLocalDate(this.datePipe.transform(dateOfBirth, "MM/dd/yyyy"))) || '');
    this.formdata["questionsDetails"] = { controls: [] };
    this.formdata.questionsDetails.controls = this.questionsFormData.controls;
    var data = {
      //referal
      ReferringSourceId: this.formdata.userDetails.controls.find((x: { name: any; }) => x.name == "referralSource")?.value,
      ReferringSourceName: this.referralSourceList.find((xz: any) => xz.Id.toString() == this.formdata.userDetails.controls.find((x: { name: any; }) => x.name == "referralSource").value)?.Title,
      ReferalType: this.referralTypeList.find((xz: any) => xz.Id.toString() == this.formdata.userDetails.controls.find((x: { name: any; }) => x.name == "referalIssueType").value)?.Title,
      ReferalTypeId: this.formdata.userDetails.controls.find((x: { name: any; }) => x.name == "referalIssueType").value,
      ReferalInvolvedType: this.involvedPartyTypeName,
      ReferalIncidentStartDt: this.formdata.userDetails.controls.find((x: { name: any; }) => x.name == "incidentStartDt")?.value,
      ReferalIncidentEndDt: this.formdata.userDetails.controls.find((x: { name: any; }) => x.name == "incidentEndDt")?.value,
      SuspectActivityFrom: this.formdata.userDetails.controls.find((x: { name: any; }) => x.name == "incidentStartDt")?.value,
      SuspectActivityTo: this.formdata.userDetails.controls.find((x: { name: any; }) => x.name == "incidentEndDt")?.value,
      ReferralFirstName: ReferralFirstName,
      ReferralMiddleName: ReferralMiddleName,
      ReferralLastName: ReferralLastName,
      ReferralSuffix: ReferralSuffix,
      ReferralDateOfBirth: ReferralDateOfBirth,
      ReferralTitle: ReferralTitle,
      ReferralOrganizationName: ReferralOrganizationName,
      ReferralIdNumber: ReferralIdNumber,
      ReferralSSN: ReferralSSN,
      ReferralPhone: ReferralPhone,
      ReferralEmail: ReferralEmail,
      ReferralAddress1: ReferralAddress1,
      ReferralAddress2: ReferralAddress2,
      ReferralCity: ReferralCity,
      ReferralState: ReferralState,
      ReferralZipCode: ReferralZipCode,
      ReferralCounty: ReferralCounty,
      ReferralRelationship: ReferralRelationship,
      IsAnonymousParty: IsAnonymousParty,

      IncidentState: this.formdata.userDetails.controls.find((x: { name: any; }) => x.name == "incidentState")?.value,
      IncidentCounty: this.formdata.userDetails.controls.find((x: { name: any; }) => x.name == "incidentCounty")?.value,
      ReferralSummary: this.formdata.userDetails.controls.find((x: { name: any; }) => x.name == "referralSummary")?.value,
      AssociatedLeadReasonId: this.associatedLeadReasonId,

      //ContactDetails
      ContactFirstName: ContactFormFirstName,
      ContactLastName: ContactFormLastName,
      ContactNameSuffix: ContactFormNameSuffix,
      ContactTitle: ContactFormTitle,
      ContactAgencyName: ContactFormAgencyName,
      ContactRelationship: ContactFormindRelationship,
      ContactPhone: ContactFormPhone,
      ContactEmail: ContactFormEmail,
      ContactAddress1: ContactFormAddress1,
      ContactAddress2: ContactFormAddress2,
      ContactCity: ContactFormCity,
      ContactState: ContactFormState,
      ContactZipCode: ContactFormZip,

      //subject
      SubjectTypeKey: this.subjectTypeId,
      SubjectOrganizationName: sourceCode,
      SubjectNamePrefix: namePrefix,
      SubjectFirstName: firstName,
      SubjectMiddleName: middleName,
      SubjectLastName: lastName,
      SubjectNameSuffix: nameSuffix,
      SubjectDesignation: designation,
      SubjectDateOfBirthForPDF: subjectPdfdateOfBirth,
      SubjectDateOfBirth: dateOfBirth,
      SubjectSsn: ssn,
      SubjectLicenceNumber: licenceNumber,
      SubjectManualSubjectId: manualSubjectID,
      SubjectNpi: npi,
      SubjectTin: tin,
      SubjectMedicaidId: medicaidId,
      SubjectMedicareId: medicareId,
      SubjectOtherId: otherId,
      SubjectProviderType: providerType,
      SubjectProviderSpecialty: ProviderSpecialty,
      SubjectTaxonomyId: taxonomyId,
      SubjectOther: other,
      SubjectStreetAddress1: streetAddress1,
      SubjectStreetAddress2: streetAddress2,
      SubjectCity: city,
      SubjectState: state,
      SubjectCounty: county,
      SubjectZip: zip,
      SubjectCountry: country,
      SubjectPhone: phone,
      SubjectSecondaryPhone: secondaryPhone,
      SubjectFax: fax,
      SubjectEmail: email,
      SubjectGender: gender,
      SubjectPlan: plan,
      SubjectProgram: program,
      SubjectLob: lob,
      SubjectGroup: group,
      SubjectContactNamePrefix: contactNamePrefix,
      SubjectContactFirstName: contactFirstName,
      SubjectContactMiddleName: contactMiddleName,
      SubjectContactLastName: contactLastName,
      SubjectContactDesignation: contactDesignation,
      ProfileMasterTypeKey: this.profileMasterTypeKey,

      //Question
      QuestionList: this.formdata.questionsDetails.controls,
      FCComplaintsJson: JSON.stringify(this.formdata),
      TimeZoneUtcDifference: (new Date()).getTimezoneOffset(),

      UploadFileNames: this.uploadFiles,
      isAnonymousValue: isAnonymousValue
    };

    this.vendorService.createLead(this.payorkey, data).subscribe({
      next: (result) => {
        if (result.IsSuccess) {
          this.leadData = result;
          if (result.CaseActivityKey) {
            sessionStorage.setItem('caseActivityKey', result.CaseActivityKey);
          }

          if (!this.isUploadAttatchment || this.uploadFiles.length === 0) {
            localStorage.removeItem('isNewReferral');
            sessionStorage.removeItem('returningFromThanksCard');
            this.sendReferralEmail(result);
          } else {
            this.vendorService.sendUploadStartData(result);
          }
        } else {
          sessionStorage.removeItem('activeformdata');
          this.router.navigateByUrl('/' + (sessionStorage.getItem('securityCode') ?? ''));
        }
      },
      error: (error) => {
        console.error('Error creating lead:', error);
      }
    });
  }

  sendReferralEmail(result: any) {
    var param = {
      lead: result.ExternalLeadItem,
      payorkey: this.payorkey,
      leadid: result.LeadId,
      leadKeyForResult: result.LeadKey,
      caseActivityKeyForResult: result.CaseActivityKey,
    }
    this.vendorService.sendReferralEmail(param).subscribe((res) => {
      this.router.navigate(['final']);
    });
  }

  assignSubjectType() {
    this.resetSubjectTypeForms();
    switch (this.profileMasterTypeKey) {
      case 1:
        this.setProviderForm();
        break;
      case 2:
        this.setMemberForm();
        break;
      case 3:
        this.setNonEnumProviderForm();
        break;
      case 4:
        this.setNonEnumOrgForm();
        break;
      case 5:
        this.setNonEnumIndForm();
        break;
      default:
        break;
    }
    this.triggerValidationForDynamicForms();
  }

  setProviderForm() {
    if (this.subjectReqFields.length > 0) {
      this.setValidatorIfExists(this.providerFormDataPart1, "pOrgName", this.subjectReqFields.find((x: any) => x.FieldName === 'organizationName')?.IsRequired);
      this.setValidatorIfExists(this.providerFormDataPart1, "pFirstName", this.subjectReqFields.find((x: any) => x.FieldName === 'firstName')?.IsRequired);
      this.setValidatorIfExists(this.providerFormDataPart1, "pLastName", this.subjectReqFields.find((x: any) => x.FieldName === 'lastName')?.IsRequired);
      this.setValidatorIfExists(this.providerFormDataPart1, "pDesignation", this.subjectReqFields.find((x: any) => x.FieldName === 'designation')?.IsRequired);
      this.setValidatorIfExists(this.providerFormDataPart1, "pManualSubjectID", this.subjectReqFields.find((x: any) => x.FieldName === 'manualSubjectID')?.IsRequired);
      this.setValidatorIfExists(this.providerFormDataPart1, "pNPI", this.subjectReqFields.find((x: any) => x.FieldName === 'npi')?.IsRequired);
      this.setValidatorIfExists(this.providerFormDataPart1, "pTIN", this.subjectReqFields.find((x: any) => x.FieldName === 'federalTIN')?.IsRequired);
      this.setValidatorIfExists(this.providerFormDataPart1, "pLicenseNo", this.subjectReqFields.find((x: any) => x.FieldName === 'license')?.IsRequired);
      this.setValidatorIfExists(this.providerFormDataPart2, "pStreetAddress1", this.subjectReqFields.find((x: any) => x.FieldName === 'addressLine1')?.IsRequired);
      this.setValidatorIfExists(this.providerFormDataPart2, "pCity", this.subjectReqFields.find((x: any) => x.FieldName === 'city')?.IsRequired);
      this.setValidatorIfExists(this.providerFormDataPart2, "pState", this.subjectReqFields.find((x: any) => x.FieldName === 'state')?.IsRequired);
      this.setValidatorIfExists(this.providerFormDataPart2, "pCounty", this.subjectReqFields.find((x: any) => x.FieldName === 'county')?.IsRequired);
      this.setValidatorIfExists(this.providerFormDataPart2, "pZip", this.subjectReqFields.find((x: any) => x.FieldName === 'zipCode')?.IsRequired);
      this.setValidatorIfExists(this.providerFormDataPart2, "pCountry", this.subjectReqFields.find((x: any) => x.FieldName === 'country')?.IsRequired);
      this.setValidatorIfExists(this.providerFormDataPart2, "pPhone", this.subjectReqFields.find((x: any) => x.FieldName === 'phone')?.IsRequired);
      this.setValidatorIfExists(this.providerFormDataPart2, "pEmail", this.subjectReqFields.find((x: any) => x.FieldName === 'email')?.IsRequired);
    }
  }
  setMemberForm() {
    if (this.subjectReqFields.length > 0) {
      this.setValidatorIfExists(this.memberFormDataPart1, "mFirstName", this.subjectReqFields.find((x: any) => x.FieldName === 'firstName')?.IsRequired);
      this.setValidatorIfExists(this.memberFormDataPart1, "mLastName", this.subjectReqFields.find((x: any) => x.FieldName === 'lastName')?.IsRequired);
      this.setValidatorIfExists(this.memberFormDataPart1, "mDateOfBirth", this.subjectReqFields.find((x: any) => x.FieldName === 'dateofBirth')?.IsRequired);
      this.setValidatorIfExists(this.memberFormDataPart1, "mGender", this.subjectReqFields.find((x: any) => x.FieldName === 'gender')?.IsRequired);
      this.setValidatorIfExists(this.memberFormDataPart1, "mOther", this.subjectReqFields.find((x: any) => x.FieldName === 'other')?.IsRequired);
      this.setValidatorIfExists(this.memberFormDataPart1, "mID", this.subjectReqFields.find((x: any) => x.FieldName === 'manualSubjectID')?.IsRequired);
      this.setValidatorIfExists(this.memberFormDataPart1, "mSSN", this.subjectReqFields.find((x: any) => x.FieldName === 'ssn')?.IsRequired);
      this.setValidatorIfExists(this.memberFormDataPart2, "mAddress1", this.subjectReqFields.find((x: any) => x.FieldName === 'addressLine1')?.IsRequired);
      this.setValidatorIfExists(this.memberFormDataPart2, "mCity", this.subjectReqFields.find((x: any) => x.FieldName === 'city')?.IsRequired);
      this.setValidatorIfExists(this.memberFormDataPart3, "mState", this.subjectReqFields.find((x: any) => x.FieldName === 'state')?.IsRequired);
      this.setValidatorIfExists(this.memberFormDataPart3, "mCounty", this.subjectReqFields.find((x: any) => x.FieldName === 'county')?.IsRequired);
      this.setValidatorIfExists(this.memberFormDataPart3, "mZip", this.subjectReqFields.find((x: any) => x.FieldName === 'zipCode')?.IsRequired);
      this.setValidatorIfExists(this.memberFormDataPart4, "mPrimaryPhone", this.subjectReqFields.find((x: any) => x.FieldName === 'phone')?.IsRequired);
      this.setValidatorIfExists(this.memberFormDataPart4, "mEmail", this.subjectReqFields.find((x: any) => x.FieldName === 'email')?.IsRequired);
    }
  }

  setNonEnumProviderForm() {
    if (this.subjectReqFields.length > 0) {
      this.setValidatorIfExists(this.noeProviderFormDataPart1, "nepOrgName", this.subjectReqFields.find((x: any) => x.FieldName === 'organizationName')?.IsRequired);
      this.setValidatorIfExists(this.noeProviderFormDataPart1, "nepFirstName", this.subjectReqFields.find((x: any) => x.FieldName === 'firstName')?.IsRequired);
      this.setValidatorIfExists(this.noeProviderFormDataPart1, "nepLastName", this.subjectReqFields.find((x: any) => x.FieldName === 'lastName')?.IsRequired);
      this.setValidatorIfExists(this.noeProviderFormDataPart1, "nepDesignation", this.subjectReqFields.find((x: any) => x.FieldName === 'designation')?.IsRequired);
      this.setValidatorIfExists(this.noeProviderFormDataPart1, "nepSsn", this.subjectReqFields.find((x: any) => x.FieldName === 'ssn')?.IsRequired);
      this.setValidatorIfExists(this.noeProviderFormDataPart1, "nepOther", this.subjectReqFields.find((x: any) => x.FieldName === 'other')?.IsRequired);
      this.setValidatorIfExists(this.noeProviderFormDataPart1, "nepLicenseNo", this.subjectReqFields.find((x: any) => x.FieldName === 'license')?.IsRequired);
      this.setValidatorIfExists(this.noeProviderFormDataPart2, "nepPrimaryPhone", this.subjectReqFields.find((x: any) => x.FieldName === 'phone')?.IsRequired);
      this.setValidatorIfExists(this.noeProviderFormDataPart2, "nepEmail", this.subjectReqFields.find((x: any) => x.FieldName === 'email')?.IsRequired);
      this.setValidatorIfExists(this.noeProviderFormDataPart2, "nepStreetAddress1", this.subjectReqFields.find((x: any) => x.FieldName === 'addressLine1')?.IsRequired);
      this.setValidatorIfExists(this.noeProviderFormDataPart2, "nepCity", this.subjectReqFields.find((x: any) => x.FieldName === 'city')?.IsRequired);
      this.setValidatorIfExists(this.noeProviderFormDataPart3, "nepState", this.subjectReqFields.find((x: any) => x.FieldName === 'state')?.IsRequired);
      this.setValidatorIfExists(this.noeProviderFormDataPart3, "nepCounty", this.subjectReqFields.find((x: any) => x.FieldName === 'county')?.IsRequired);
      this.setValidatorIfExists(this.noeProviderFormDataPart3, "nepZip", this.subjectReqFields.find((x: any) => x.FieldName === 'zipCode')?.IsRequired);
      this.setValidatorIfExists(this.noeProviderFormDataPart4, "nepCountry", this.subjectReqFields.find((x: any) => x.FieldName === 'country')?.IsRequired);

    }
  }

  setNonEnumOrgForm() {
    if (this.subjectReqFields.length > 0) {
      this.setValidatorIfExists(this.noeOrgFormDataPart1, "neoOrgName", this.subjectReqFields.find((x: any) => x.FieldName === 'organizationName')?.IsRequired);
      this.setValidatorIfExists(this.noeOrgFormDataPart1, "neoTIN", this.subjectReqFields.find((x: any) => x.FieldName === 'federalTIN')?.IsRequired);
      this.setValidatorIfExists(this.noeOrgFormDataPart1, "neoLicenseNo", this.subjectReqFields.find((x: any) => x.FieldName === 'license')?.IsRequired);
      this.setValidatorIfExists(this.noeOrgFormDataPart1, "neoOther", this.subjectReqFields.find((x: any) => x.FieldName === 'other')?.IsRequired);
      this.setValidatorIfExists(this.noeOrgFormDataPart1, "neoOtherId", this.subjectReqFields.find((x: any) => x.FieldName === 'otherID')?.IsRequired);
      this.setValidatorIfExists(this.noeOrgFormDataPart1, "neoContactFirstName", this.subjectReqFields.find((x: any) => x.FieldName === 'contactFirstName')?.IsRequired);
      this.setValidatorIfExists(this.noeOrgFormDataPart1, "neoContactLastName", this.subjectReqFields.find((x: any) => x.FieldName === 'contactLastName')?.IsRequired);
      this.setValidatorIfExists(this.noeOrgFormDataPart1, "neoContactDesignation", this.subjectReqFields.find((x: any) => x.FieldName === 'contactDesignation')?.IsRequired);
      this.setValidatorIfExists(this.noeOrgFormDataPart2, "neoPhone", this.subjectReqFields.find((x: any) => x.FieldName === 'phone')?.IsRequired);
      this.setValidatorIfExists(this.noeOrgFormDataPart2, "neoEmail", this.subjectReqFields.find((x: any) => x.FieldName === 'email')?.IsRequired);
      this.setValidatorIfExists(this.noeOrgFormDataPart2, "neoStreetAddress1", this.subjectReqFields.find((x: any) => x.FieldName === 'addressLine1')?.IsRequired);
      this.setValidatorIfExists(this.noeOrgFormDataPart2, "neoCity", this.subjectReqFields.find((x: any) => x.FieldName === 'city')?.IsRequired);
      this.setValidatorIfExists(this.noeOrgFormDataPart3, "neoState", this.subjectReqFields.find((x: any) => x.FieldName === 'state')?.IsRequired);
      this.setValidatorIfExists(this.noeOrgFormDataPart3, "neoCounty", this.subjectReqFields.find((x: any) => x.FieldName === 'county')?.IsRequired);
      this.setValidatorIfExists(this.noeOrgFormDataPart3, "neoZip", this.subjectReqFields.find((x: any) => x.FieldName === 'zipCode')?.IsRequired);
      this.setValidatorIfExists(this.noeOrgFormDataPart4, "neoCountry", this.subjectReqFields.find((x: any) => x.FieldName === 'country')?.IsRequired);

    }
  }

  setNonEnumIndForm() {
    if (this.subjectReqFields.length > 0) {
      this.setValidatorIfExists(this.noeIndFormDataPart1, "neiNamePrefix", this.subjectReqFields.find((x: any) => x.FieldName === 'prefix')?.IsRequired);
      this.setValidatorIfExists(this.noeIndFormDataPart1, "neiFirstName", this.subjectReqFields.find((x: any) => x.FieldName === 'firstName')?.IsRequired);
      this.setValidatorIfExists(this.noeIndFormDataPart1, "neiLastName", this.subjectReqFields.find((x: any) => x.FieldName === 'lastName')?.IsRequired);
      this.setValidatorIfExists(this.noeIndFormDataPart1, "neiDesignation", this.subjectReqFields.find((x: any) => x.FieldName === 'designation')?.IsRequired);
      this.setValidatorIfExists(this.noeIndFormDataPart1, "neiDateOfBirth", this.subjectReqFields.find((x: any) => x.FieldName === 'dateofBirth')?.IsRequired);
      this.setValidatorIfExists(this.noeIndFormDataPart1, "neiOther", this.subjectReqFields.find((x: any) => x.FieldName === 'other')?.IsRequired);
      this.setValidatorIfExists(this.noeIndFormDataPart2, "neiPrimaryPhone", this.subjectReqFields.find((x: any) => x.FieldName === 'phone')?.IsRequired);
      this.setValidatorIfExists(this.noeIndFormDataPart2, "neiEmail", this.subjectReqFields.find((x: any) => x.FieldName === 'email')?.IsRequired);
      this.setValidatorIfExists(this.noeIndFormDataPart2, "neiStreetAddress1", this.subjectReqFields.find((x: any) => x.FieldName === 'addressLine1')?.IsRequired);
      this.setValidatorIfExists(this.noeIndFormDataPart2, "neiCity", this.subjectReqFields.find((x: any) => x.FieldName === 'city')?.IsRequired);
      this.setValidatorIfExists(this.noeIndFormDataPart3, "neiState", this.subjectReqFields.find((x: any) => x.FieldName === 'state')?.IsRequired);
      this.setValidatorIfExists(this.noeIndFormDataPart3, "neiCounty", this.subjectReqFields.find((x: any) => x.FieldName === 'county')?.IsRequired);
      this.setValidatorIfExists(this.noeIndFormDataPart3, "neiZip", this.subjectReqFields.find((x: any) => x.FieldName === 'zipCode')?.IsRequired);
    }
  }

  createLocalDate(date?: any) {
    if (date === null || date === '') return '';
    const dateParts = date.split('/');
    const year = parseInt(dateParts[2], 10);
    const month = parseInt(dateParts[0], 10) - 1;
    const day = parseInt(dateParts[1], 10);

    const dateValue = new Date(year, month, day, 0, 0, 0);
    return dateValue;
  }

  setCounties(name: string, stateOptions: any) {
    switch (name) {
      case "incidentState":
        this.setOptionsIfExists(this.userFormDataPart5, "incidentCounty", stateOptions);
        break;
      case "thirdState":
        this.setOptionsIfExists(this.thirdPartyReferringPartyDataPart4, "thirdCounty", stateOptions);
        break;
      case "sepState":
        this.setOptionsIfExists(this.selfReferringPartyDataPart4, "sepCounty", stateOptions);
        break;
      case "pState":
        this.setOptionsIfExists(this.providerFormDataPart2, "pCounty", stateOptions);
        break;
      case "mState":
        this.setOptionsIfExists(this.memberFormDataPart3, "mCounty", stateOptions);
        break;
      case "nepState":
        this.setOptionsIfExists(this.noeProviderFormDataPart3, "nepCounty", stateOptions);
        break;
      case "neoState":
        this.setOptionsIfExists(this.noeOrgFormDataPart3, "neoCounty", stateOptions);
        break;
      case "neiState":
        this.setOptionsIfExists(this.noeIndFormDataPart3, "neiCounty", stateOptions);
        break;
    }
  }

  setIndividualReferringPartyForm() {
    let result = this.requiredFieldData;

    const individualReferringPartyControls = this.formdata.individualReferringPartyDetails.controls;
    this.individualReferringPartyDataPart1["controls"] = individualReferringPartyControls.slice(0, 6);
    this.individualReferringPartyDataPart2["controls"] = individualReferringPartyControls.slice(6, 11);
    this.individualReferringPartyDataPart3["controls"] = individualReferringPartyControls.slice(11, 12);
    this.individualReferringPartyDataPart4["controls"] = individualReferringPartyControls.slice(12, 14);

    const stateOptions = this.statelist.map(x => ({ value: x.Abbreviation, key: x.Abbreviation }));

    this.setOptionsIfExists(this.individualReferringPartyDataPart3, "indState", stateOptions);

    this.setValidatorIfExists(this.individualReferringPartyDataPart1, "indFirstName", result.IndividualReferringPartyFirstName);
    this.setValidatorIfExists(this.individualReferringPartyDataPart1, "indMiddleName", result.IndividualReferringPartyMiddleName);
    this.setValidatorIfExists(this.individualReferringPartyDataPart1, "indLastName", result.IndividualReferringPartyLastName);
    this.setValidatorIfExists(this.individualReferringPartyDataPart1, "indSuffix", result.IndividualReferringPartyNameSuffix);
    this.setValidatorIfExists(this.individualReferringPartyDataPart1, "indTitle", result.IndividualReferringPartyDesignation);
    this.setValidatorIfExists(this.individualReferringPartyDataPart1, "indOrgName", result.IndividualReferringPartyOrganizationAgencyName);
    this.setValidatorIfExists(this.individualReferringPartyDataPart1, "indRelationship", result.IndividualReferringPartyRelation);
    this.setValidatorIfExists(this.individualReferringPartyDataPart2, "indPhone", result.IndividualReferringPartyPhoneNumber);
    this.setValidatorIfExists(this.individualReferringPartyDataPart2, "indEmail", result.IndividualReferringPartyEmailAddress);
    this.setValidatorIfExists(this.individualReferringPartyDataPart2, "indAddress1", result.IndividualReferringPartyMailingAddressStreet1);
    this.setValidatorIfExists(this.individualReferringPartyDataPart2, "indAddress2", result.IndividualReferringPartyMailingAddressStreet2);
    this.setValidatorIfExists(this.individualReferringPartyDataPart2, "indCity", result.IndividualReferringPartyMailingAddressCity);
    this.setValidatorIfExists(this.individualReferringPartyDataPart3, "indState", result.IndividualReferringPartyMailingAddressState);
    this.setValidatorIfExists(this.individualReferringPartyDataPart4, "indZip", result.IndividualReferringPartyMailingAddressZip);
  }

  setSelfReferringPartyForm() {
    let result = this.requiredFieldData;
    const selfReferringPartyControls = this.formdata.selfReferringPartyDetails.controls;
    this.selfReferringPartyDataPart1["controls"] = selfReferringPartyControls.slice(0, 9);
    this.selfReferringPartyDataPart2["controls"] = selfReferringPartyControls.slice(9, 14);
    this.selfReferringPartyDataPart3["controls"] = selfReferringPartyControls.slice(14, 16);
    this.selfReferringPartyDataPart4["controls"] = selfReferringPartyControls.slice(16, 18);

    const stateOptions = this.statelist.map(x => ({ value: x.Abbreviation, key: x.Abbreviation }));
    this.setOptionsIfExists(this.selfReferringPartyDataPart3, "sepState", stateOptions);

    this.setValidatorIfExists(this.selfReferringPartyDataPart1, "sepFirstName", result.SelfReferringPartyFirstName);
    this.setValidatorIfExists(this.selfReferringPartyDataPart1, "sepMiddleName", result.SelfReferringPartyMiddleName);
    this.setValidatorIfExists(this.selfReferringPartyDataPart1, "sepLastName", result.SelfReferringPartyLastName);
    this.setValidatorIfExists(this.selfReferringPartyDataPart1, "sepSuffix", result.SelfReferringPartyNameSuffix);
    this.setValidatorIfExists(this.selfReferringPartyDataPart1, "sepTitle", result.SelfReferringPartyDesignation);
    this.setValidatorIfExists(this.selfReferringPartyDataPart1, "sepOrgName", result.SelfReferringPartyOrganizationAgencyName);
    this.setValidatorIfExists(this.selfReferringPartyDataPart1, "sepDateOfBirth", result.SelfReferringPartyDateOfBirth);
    this.setValidatorIfExists(this.selfReferringPartyDataPart1, "sepIdNumber", result.SelfReferringPartyIdNumber);
    this.setValidatorIfExists(this.selfReferringPartyDataPart1, "sepSSN", result.SelfReferringPartySSN);
    this.setValidatorIfExists(this.selfReferringPartyDataPart2, "sepPhone", result.SelfReferringPartyPhoneNumber);
    this.setValidatorIfExists(this.selfReferringPartyDataPart2, "sepEmail", result.SelfReferringPartyEmailAddress);
    this.setValidatorIfExists(this.selfReferringPartyDataPart2, "sepAddress1", result.SelfReferringPartyMailingAddressStreet1);
    this.setValidatorIfExists(this.selfReferringPartyDataPart2, "sepAddress2", result.SelfReferringPartyMailingAddressStreet2);
    this.setValidatorIfExists(this.selfReferringPartyDataPart2, "sepCity", result.SelfReferringPartyMailingAddressCity);
    this.setValidatorIfExists(this.selfReferringPartyDataPart3, "sepState", result.SelfReferringPartyMailingAddressState);
    this.setValidatorIfExists(this.selfReferringPartyDataPart3, "sepZip", result.SelfReferringPartyMailingAddressZip);
    this.setValidatorIfExists(this.selfReferringPartyDataPart4, "sepCounty", result.SelfReferringPartyMailingAddressCounty);
    this.setValidatorIfExists(this.selfReferringPartyDataPart4, "sepRelationship", result.SelfReferringPartyRelation);
  }

  setThirdPartyReferringPartyForm() {
    let result = this.requiredFieldData;
    const thirdPartyReferringPartyControls = this.formdata.thirdPartyReferringPartyDetails.controls;
    this.thirdPartyReferringPartyDataPart1["controls"] = thirdPartyReferringPartyControls.slice(0, 9);
    this.thirdPartyReferringPartyDataPart2["controls"] = thirdPartyReferringPartyControls.slice(9, 14);
    this.thirdPartyReferringPartyDataPart3["controls"] = thirdPartyReferringPartyControls.slice(14, 16);
    this.thirdPartyReferringPartyDataPart4["controls"] = thirdPartyReferringPartyControls.slice(16, 18);

    const stateOptions = this.statelist.map(x => ({ value: x.Abbreviation, key: x.Abbreviation }));
    this.setOptionsIfExists(this.thirdPartyReferringPartyDataPart3, "thirdState", stateOptions);

    this.setValidatorIfExists(this.thirdPartyReferringPartyDataPart1, "thirdFirstName", result.ThirdPartyReferringPartyFirstName);
    this.setValidatorIfExists(this.thirdPartyReferringPartyDataPart1, "thirdMiddleName", result.ThirdPartyReferringPartyMiddleName);
    this.setValidatorIfExists(this.thirdPartyReferringPartyDataPart1, "thirdLastName", result.ThirdPartyReferringPartyLastName);
    this.setValidatorIfExists(this.thirdPartyReferringPartyDataPart1, "thirdSuffix", result.ThirdPartyReferringPartyNameSuffix);
    this.setValidatorIfExists(this.thirdPartyReferringPartyDataPart1, "thirdTitle", result.ThirdPartyReferringPartyDesignation);
    this.setValidatorIfExists(this.thirdPartyReferringPartyDataPart1, "thirdOrgName", result.ThirdPartyReferringPartyOrganizationAgencyName);
    this.setValidatorIfExists(this.thirdPartyReferringPartyDataPart1, "thirdDateOfBirth", result.ThirdPartyReferringPartyDateOfBirth);
    this.setValidatorIfExists(this.thirdPartyReferringPartyDataPart1, "thirdIdNumber", result.ThirdPartyReferringPartyIdNumber);
    this.setValidatorIfExists(this.thirdPartyReferringPartyDataPart1, "thirdSSN", result.ThirdPartyReferringPartySSN);
    this.setValidatorIfExists(this.thirdPartyReferringPartyDataPart2, "thirdPhone", result.ThirdPartyReferringPartyPhoneNumber);
    this.setValidatorIfExists(this.thirdPartyReferringPartyDataPart2, "thirdEmail", result.ThirdPartyReferringPartyEmailAddress);
    this.setValidatorIfExists(this.thirdPartyReferringPartyDataPart2, "thirdAddress1", result.ThirdPartyReferringPartyMailingAddressStreet1);
    this.setValidatorIfExists(this.thirdPartyReferringPartyDataPart2, "thirdAddress2", result.ThirdPartyReferringPartyMailingAddressStreet2);
    this.setValidatorIfExists(this.thirdPartyReferringPartyDataPart2, "thirdCity", result.ThirdPartyReferringPartyMailingAddressCity);
    this.setValidatorIfExists(this.thirdPartyReferringPartyDataPart3, "thirdState", result.ThirdPartyReferringPartyMailingAddressState);
    this.setValidatorIfExists(this.thirdPartyReferringPartyDataPart3, "thirdZip", result.ThirdPartyReferringPartyMailingAddressZip);
    this.setValidatorIfExists(this.thirdPartyReferringPartyDataPart4, "thirdCounty", result.ThirdPartyReferringPartyMailingAddressCounty);
    this.setValidatorIfExists(this.thirdPartyReferringPartyDataPart4, "thirdRelationship", result.ThirdPartyReferringPartyRelation);
  }
  resetAnonymousForms(){
    Object.keys(this.individualReferringPartyFormPart1.controls).forEach(key => {
      this.individualReferringPartyFormPart1.removeControl(key);
    });
    Object.keys(this.individualReferringPartyFormPart2.controls).forEach(key => {
      this.individualReferringPartyFormPart2.removeControl(key);
    });
    Object.keys(this.individualReferringPartyFormPart3.controls).forEach(key => {
      this.individualReferringPartyFormPart3.removeControl(key);
    });
    Object.keys(this.individualReferringPartyFormPart4.controls).forEach(key => {
      this.individualReferringPartyFormPart4.removeControl(key);
    });
    Object.keys(this.selfReferringPartyFormPart1.controls).forEach(key => {
      this.selfReferringPartyFormPart1.removeControl(key);
    });
    Object.keys(this.selfReferringPartyFormPart2.controls).forEach(key => {
      this.selfReferringPartyFormPart2.removeControl(key);
    });
    Object.keys(this.selfReferringPartyFormPart3.controls).forEach(key => {
      this.selfReferringPartyFormPart3.removeControl(key);
    });
    Object.keys(this.selfReferringPartyFormPart4.controls).forEach(key => {
      this.selfReferringPartyFormPart4.removeControl(key);
    });
    Object.keys(this.thirdPartyReferringPartyFormPart1.controls).forEach(key => {
      this.thirdPartyReferringPartyFormPart1.removeControl(key);
    });
    Object.keys(this.thirdPartyReferringPartyFormPart2.controls).forEach(key => {
      this.thirdPartyReferringPartyFormPart2.removeControl(key);
    });
    Object.keys(this.thirdPartyReferringPartyFormPart3.controls).forEach(key => {
      this.thirdPartyReferringPartyFormPart3.removeControl(key);
    });
    Object.keys(this.thirdPartyReferringPartyFormPart4.controls).forEach(key => {
      this.thirdPartyReferringPartyFormPart4.removeControl(key);
    });
  }

  resetSubjectTypeForms(){
    Object.keys(this.providerFormPart1.controls).forEach(key => {
      this.providerFormPart1.removeControl(key);
    });
    Object.keys(this.providerFormPart2.controls).forEach(key => {
      this.providerFormPart2.removeControl(key);
    });
    Object.keys(this.memberFormPart1.controls).forEach(key => {
      this.memberFormPart1.removeControl(key);
    });
    Object.keys(this.memberFormPart2.controls).forEach(key => {
      this.memberFormPart2.removeControl(key);
    });
    Object.keys(this.memberFormPart3.controls).forEach(key => {
      this.memberFormPart3.removeControl(key);
    });
    Object.keys(this.memberFormPart4.controls).forEach(key => {
      this.memberFormPart4.removeControl(key);
    });
    Object.keys(this.noeProviderFormPart1.controls).forEach(key => {
      this.noeProviderFormPart1.removeControl(key);
    });
    Object.keys(this.noeProviderFormPart2.controls).forEach(key => {
      this.noeProviderFormPart2.removeControl(key);
    });
    Object.keys(this.noeProviderFormPart3.controls).forEach(key => {
      this.noeProviderFormPart3.removeControl(key);
    });
    Object.keys(this.noeProviderFormPart4.controls).forEach(key => {
      this.noeProviderFormPart4.removeControl(key);
    });
    Object.keys(this.noeOrgFormPart1.controls).forEach(key => {
      this.noeOrgFormPart1.removeControl(key);
    });
    Object.keys(this.noeOrgFormPart2.controls).forEach(key => {
      this.noeOrgFormPart2.removeControl(key);
    });
    Object.keys(this.noeOrgFormPart3.controls).forEach(key => {
      this.noeOrgFormPart3.removeControl(key);
    });
    Object.keys(this.noeOrgFormPart4.controls).forEach(key => {
      this.noeOrgFormPart4.removeControl(key);
    });
    Object.keys(this.noeIndFormPart1.controls).forEach(key => {
      this.noeIndFormPart1.removeControl(key);
    });
    Object.keys(this.noeIndFormPart2.controls).forEach(key => {
      this.noeIndFormPart2.removeControl(key);
    });
    Object.keys(this.noeIndFormPart3.controls).forEach(key => {
      this.noeIndFormPart3.removeControl(key);
    });
  }
  onCaptchaResolved(response: string |null): void {
    this.captchaValidated = !!response;
  }
  get isSubmitEnabled(): boolean {
    return this.isFormsValid && this.captchaValidated;
  }
}
